const translations = {
  pt: {
    common: {
      loading: "Carregando…",
      systemOnline: "SISTEMA ONLINE",
      cancel: "Cancelar",
      save: "Salvar",
      edit: "Editar",
      delete: "Excluir",
      add: "Adicionar",
      search: "Buscar...",
      all: "Todos",
      total: "Total",
      status: "Status",
      date: "Data",
      description: "Descrição",
      amount: "Valor",
      value: "Valor",
      notes: "Observações",
      none: "Nenhum",
      select: "Selecione...",
      confirmDelete: "Tem certeza que deseja excluir?",
      sessionLabel: "Sessão",
      logout: "Sair",
      operations: "Operações",
      print: "Imprimir",
      details: "Detalhes",
      yes: "Sim",
      no: "Não",
      never: "Nunca",
      back: "Voltar",
      next: "Avançar",
      open: "Abrir",
    },
    sidebar: {
      dashboard: "Painel",
      today: "Hoje",
      fleet: "Frota",
      customers: "Clientes",
      rentals: "Aluguéis",
      payments: "Pagamentos",
      maintenance: "Manutenção",
      tickets: "Multas",
      tolls: "Pedágios",
      gps: "Rastreamento",
      financial: "Financeiro",
      billing: "Cobrança",
      bi: "Inteligência",
      activity: "Atividade",
      users: "Usuários",
      profile: "Perfil",
    },
    login: {
      restrictedAccess: "Acesso restrito",
      signIn: "Entrar no painel",
      useCredentials: "Use suas credenciais administrativas.",
      email: "Email",
      password: "Senha",
      submit: "Entrar",
      defaultCreds: "Credenciais padrão",
      systemVersion: "Sistema operacional · v1.0",
      heroTitle1: "Comando total",
      heroTitle2: "sobre sua frota.",
      heroDescription: "Frota, clientes, contratos, pagamentos, manutenção e rastreamento GPS — em um único painel sofisticado.",
      heroFooter: "ALL SYSTEMS NOMINAL",
      brandSub: "Sistema OS",
    },
    dashboard: {
      available: "Disponíveis",
      rented: "Alugados",
      maintenance: "Manutenção",
      overdue: "Atrasados",
      revenueMonth: "Receita do mês",
      revenueTotal: "Receita total",
      profit: "Lucro estimado",
      upcoming: "Devoluções 7d",
      ofVehicles: "de {{n}} veículos",
      activeContracts: "{{n}} contratos ativos",
      inWorkshop: "Em oficina",
      overdueReturns: "Retornos vencidos",
      confirmedPayments: "Pagamentos confirmados",
      accumulated: "Acumulado",
      expenses: "Despesas",
      scheduled: "{{n}} agendados",
      revenue: "Receita",
      last6months: "Últimos 6 meses",
      fleet: "Frota",
      currentStatus: "Status atual",
      noData: "Sem dados",
    },
    fleet: {
      pageTitle: "Frota · {{n}} veículos",
      pageSubtitle: "Gerencie seus veículos, status e informações operacionais.",
      newCar: "Novo veículo",
      registerCar: "Cadastrar veículo",
      editCar: "Editar veículo",
      model: "Modelo",
      plate: "Placa",
      year: "Ano",
      color: "Cor",
      dailyPrice: "Diária ($)",
      weeklyPrice: "Semanal ($)",
      monthlyPrice: "Mensal ($)",
      ratesTitle: "Tabela de preços",
      ratesHint: "Os valores se sugerem automaticamente quando você muda um — você pode ajustar livremente.",
      weekShort: "sem",
      dailyAutoHint: "Diária auto: ${{rate}} (semanal ÷ 7)",
      unknownRenter: "Cliente",
      dueOn: "Devolve",
      overdue: "atrasado",
      today: "hoje",
      tomorrow: "amanhã",
      pendingCharges: "Cobranças pendentes",
      mileage: "Milhas (mi)",
      gpsId: "ID do GPS",
      fuel: "Combustível",
      photo: "Foto (URL)",
      insurancePolicy: "Apólice de Seguro",
      insuranceExpiry: "Vencimento Seguro",
      maInspectionExpiry: "Vencimento Inspeção MA",
      registrationExpiry: "Vencimento Registration",
      ezpassTag: "EZPass / Transponder",
      vin: "VIN (Chassi)",
      emptyTitle: "Frota vazia",
      emptySub: "Cadastre seu primeiro veículo para começar.",
      registerFirst: "Cadastrar veículo",
      rentNow: "Alugar Agora",
      searchPlaceholder: "Buscar por placa, modelo, cor, ano...",
      noResults: "Nenhum resultado",
      tryDifferent: "Tente outros termos de busca.",
      sort: {
        newest: "Mais recentes",
        oldest: "Mais antigos",
        plateAsc: "Placa (A→Z)",
        modelAsc: "Modelo (A→Z)",
        priceDesc: "Maior diária",
        priceAsc: "Menor diária",
        mileageAsc: "Menor milhagem",
        mileageDesc: "Maior milhagem",
      },
      status: {
        disponivel: "Disponível",
        alugado: "Alugado",
        manutencao: "Manutenção",
      },
      created: "Veículo cadastrado",
      updated: "Veículo atualizado",
      deleted: "Veículo excluído",
      confirmDelete: "Excluir este veículo?",
    },
    customers: {
      pageTitle: "Clientes · {{n}} cadastrados",
      pageSubtitle: "Cadastro completo com Social Security, Driver License e contato.",
      newCustomer: "Novo cliente",
      registerCustomer: "Cadastrar cliente",
      editCustomer: "Editar cliente",
      fullName: "Nome completo",
      ssn: "Social Security (SSN)",
      license: "Driver License",
      phone: "Telefone",
      email: "Email",
      address: "Endereço",
      preferredLanguage: "Idioma preferido (para recibos e WhatsApp)",
      preferredLanguageHint: "Recibos e mensagens automáticas serão gerados neste idioma",
      emptyTitle: "Nenhum cliente",
      emptySub: "Cadastre clientes para criar contratos de aluguel.",
      created: "Cliente cadastrado",
      updated: "Cliente atualizado",
      deleted: "Cliente excluído",
      confirmDelete: "Excluir cliente?",
    },
    rentals: {
      pageTitle: "Aluguéis · {{n}} contratos",
      pageSubtitle: "Contratos, datas e status. Receita calculada automaticamente.",
      newRental: "Novo aluguel",
      openEnded: "Em aberto",
      wizardBtn: "Novo aluguel rápido",
      editRental: "Editar aluguel",
      vehicle: "Veículo",
      customer: "Cliente",
      pickup: "Retirada",
      return: "Devolução",
      billingType: "Tipo de cobrança",
      daily: "Diária",
      weekly: "Semanal",
      dailyRate: "Valor da diária ($)",
      weeklyRate: "Valor da semanal ($)",
      deposit: "Caução ($)",
      rentalValue: "Valor do aluguel",
      pickupTotal: "Total a cobrar na entrega",
      pickupHint: "Aluguel + Caução · refundável",
      billing: "Cobrança",
      perDay: "/dia",
      perWeek: "/semana",
      paymentCol: "Pagamento",
      emptyTitle: "Sem contratos",
      emptySub: "Crie um aluguel para começar a operar.",
      created: "Aluguel criado",
      updated: "Aluguel atualizado",
      deleted: "Aluguel excluído",
      confirmDelete: "Excluir aluguel?",
      detailsTitle: "Detalhes, EZ-Pass e recibos",
      day: "dia",
      days: "dias",
      week: "semana",
      weeks: "semanas",
      status: {
        agendado: "Agendado",
        ativo: "Ativo",
        concluido: "Concluído",
        cancelado: "Cancelado",
      },
    },
    payments: {
      pageTitle: "Pagamentos · {{n}} registros",
      pageSubtitle: "Recebimentos e pendências por contrato.",
      newPayment: "Registrar pagamento",
      contract: "Contrato (aluguel)",
      amount: "Valor ($)",
      method: "Método",
      received: "Recebido",
      pending: "Pendente",
      methods: {
        dinheiro: "Dinheiro",
        pix: "PIX",
        zelle: "Zelle",
        cartao: "Cartão",
        transferencia: "Transferência",
      },
      status: {
        pago: "Pago",
        pendente: "Pendente",
      },
      contractCol: "Contrato",
      emptyTitle: "Sem pagamentos",
      created: "Pagamento registrado",
      deleted: "Pagamento excluído",
      confirmDelete: "Excluir pagamento?",
      downloadReceipt: "Baixar recibo PDF",
    },
    maintenance: {
      pageTitle: "Manutenção · {{n}} registros · {{cost}} em despesas",
      pageSubtitle: "Histórico de serviços por veículo.",
      newMaintenance: "Registrar manutenção",
      newTitle: "Nova manutenção",
      serviceType: "Tipo de serviço",
      servicePlaceholder: "Ex: Troca de óleo, Revisão 20.000mi",
      cost: "Custo ($)",
      mileageAt: "Milhas no momento",
      performedAt: "Realizada em",
      nextAt: "Próxima em",
      optional: "opcional",
      service: "Serviço",
      next: "Próxima",
      miles: "Milhas",
      emptyTitle: "Sem manutenções",
      created: "Manutenção registrada",
      deleted: "Manutenção excluída",
      confirmDelete: "Excluir manutenção?",
    },
    gps: {
      pageTitle: "Rastreamento · {{n}} com GPS",
      pageSubtitle: "Última localização conhecida e atualização manual de coordenadas. Integração com provedor pode ser adicionada depois.",
      active: "Ativo",
      noGps: "Sem GPS",
      device: "Dispositivo",
      latitude: "Latitude",
      longitude: "Longitude",
      odometer: "Hodômetro",
      updated: "Atualizado",
      updateBtn: "Atualizar",
      updateTitle: "Atualizar localização",
      odometerInput: "Hodômetro (mi)",
      hint: "Dica: cole coordenadas do Google Maps no formato lat, lng.",
      noVehicles: "Nenhum veículo cadastrado",
      locationUpdated: "Localização atualizada",
    },
    financial: {
      pageTitle: "Financeiro",
      revenueTotal: "Receita total",
      revenueMonth: "Receita do mês",
      expenses: "Despesas",
      profit: "Lucro",
      monthlyRevenue: "Receita mensal",
      last6: "Últimos 6 meses",
      perVehicle: "Desempenho por veículo",
      revenueVsCost: "Receita × Custos",
      vehicle: "Veículo",
      revenue: "Receita",
      costs: "Custos",
    },
    receipt: {
      pickup: "Recibo de entrega",
      return: "Recibo de devolução",
      brand: "LOCADORA",
      receiptNo: "Recibo nº",
      pickupTitle: "RECIBO DE ENTREGA",
      returnTitle: "RECIBO DE DEVOLUÇÃO",
      issuedAt: "Emitido em",
      customer: "Cliente",
      vehicle: "Veículo",
      period: "Período do aluguel",
      pickupDate: "Retirada",
      returnDate: "Devolução",
      billing: "Cobrança",
      quantity: "Quantidade",
      unitRate: "Valor unitário",
      rentalValue: "Valor do aluguel",
      pickupTotalSection: "Total a pagar na entrega",
      rental: "Aluguel",
      depositRefundable: "Caução (refundável)",
      totalPaid: "TOTAL PAGO",
      pickupNote: "* O valor de {{deposit}} referente ao caução será devolvido ao cliente no momento da devolução do veículo, descontados pedágios (EZ-Pass), combustível faltante, limpeza, danos e outros gastos extras.",
      tollsSection: "Caução e gastos extras",
      depositPaid: "Caução pago na entrega",
      tollsTotal: "Total gastos extras",
      noTolls: "Nenhum gasto extra registrado.",
      refundSection: "Saldo devolvido ao cliente",
      depositLine: "Caução",
      tollsDeduct: "(−) Gastos extras",
      refundedAmount: "VALOR REEMBOLSADO",
      excessNote: "* Os pedágios excedem o caução. Cliente deve pagar {{excess}} adicional.",
      signCustomer: "Cliente",
      signCompany: "Locadora",
      responsible: "Responsável",
      eDoc: "Documento emitido eletronicamente",
      ezpassCol: "Descrição",
    },
    rentalDetails: {
      depositLabel: "Caução",
      ezpassTotal: "Gastos extras total",
      depositMinus: "Caução − Gastos",
      pickupReceiptBtn: "Recibo de entrega",
      returnReceiptBtn: "Recibo de devolução",
      sendCheckinLink: "Check-in do cliente",
      checkinLinkCopied: "Link de check-in copiado",
      requestReview: "Pedir avaliação Google",
      reviewLinkCopied: "Link copiado",
      ezpassSection: "Gastos extras · descontados do caução",
      placeholderToll: "Ex: Ponte GW Bridge",
      addToll: "Lançar",
      ezpassAdded: "Lançamento adicionado",
      removed: "Removido",
      category: "Categoria",
      categories: {
        ezpass: "EZ-Pass / Pedágio",
        fuel: "Combustível",
        cleaning: "Limpeza",
        damage: "Danos",
        other: "Outros",
      },
      placeholders: {
        ezpass: "Ex: GW Bridge",
        fuel: "Ex: Devolvido com tanque vazio (deveria estar cheio)",
        cleaning: "Ex: Limpeza interna profunda",
        damage: "Ex: Risco na porta dianteira",
        other: "Ex: Multa de trânsito",
      },
      tabCharges: "Cobranças",
      tabPhotos: "Fotos",
      tabChecklist: "Vistoria",
      tabSignature: "Assinatura",
      tabReturnReport: "Relatório devolução",
    },
    billing: {
      chargeViaWhatsapp: "Cobrar via WhatsApp",
      linkGenerated: "Link de pagamento gerado",
      sentAutomatically: "✅ Cobrança enviada automaticamente por WhatsApp",
      zelleOnly: "Cobrar via Zelle",
      zelleOnlyHint: "Envia somente dados Zelle/PIX (sem link Stripe)",
      zelleSentAutomatically: "✅ Mensagem Zelle enviada automaticamente por WhatsApp",
      zelleMessageReady: "Mensagem Zelle pronta",
      zelleReadyToSend: "Cobrança Zelle pronta",
      zelleQrShare: "QR Code do Zelle será compartilhado com o cliente",
      linkCopied: "Link copiado",
      readyToSend: "Pronto para enviar",
      openWhatsapp: "Abrir no WhatsApp",
      previewLink: "Ver link",
      copyLink: "Copiar link",
      previewMessage: "Mensagem que será enviada",
      noPhone: "Cliente sem telefone cadastrado",
      paymentSuccess: "Pagamento confirmado!",
      paymentSuccessMsg: "Obrigado. Sua transação foi processada com sucesso.",
      paymentCancelled: "Pagamento cancelado",
      paymentCancelledMsg: "Você pode tentar novamente quando quiser.",
      backToApp: "Voltar ao sistema",
      checkingStatus: "Verificando status do pagamento…",
    },
    billingPage: {
      title: "Cobrança programada · {{n}} contratos",
      subtitle: "Aluguéis semanais com cobrança vencendo nas próximas 48h ou já em atraso.",
      emptyTitle: "Tudo em dia",
      emptySub: "Nenhuma cobrança pendente nos próximos dias.",
      dueIn: "Vence em",
      overdueBy: "Atrasado há",
    },
    photos: {
      uploadBtn: "Enviar fotos",
      dropHint: "Arraste fotos aqui ou clique para selecionar (até 8MB cada)",
      empty: "Nenhuma foto enviada ainda.",
      uploadedN: "{{n}} arquivo(s) enviado(s)",
      deleted: "Foto removida",
      confirmDelete: "Remover esta foto?",
      carPhotos: "Galeria do veículo",
      carPhotosHint: "Fotos oficiais do carro: exterior, interior, painel, hodômetro.",
      pickupCondition: "Estado na entrega",
      pickupConditionHint: "Documente o estado do veículo no momento da entrega ao cliente.",
      returnCondition: "Estado na devolução",
      returnConditionHint: "Documente o estado e eventuais danos no momento da devolução.",
      customerDocs: "Documentos do cliente",
      customerDocsHint: "CNH, Social Security ou outros documentos. PDF e imagens aceitos.",
    },
    signature: {
      title: "Assinatura digital do cliente",
      hint: "Use mouse ou toque",
      placeholder: "ASSINE AQUI",
      clear: "Limpar",
      save: "Salvar assinatura",
      saved: "Assinatura salva",
      savedAndStored: "Assinatura salva e contrato armazenado no perfil do cliente",
      emptyError: "Assine antes de salvar.",
      remove: "Remover",
      removed: "Assinatura removida",
      confirmRemove: "Remover a assinatura?",
      signedOn: "Assinado em",
      initialsLabel: "Iniciais",
      initialsHint: "Digite as iniciais do cliente (ex: JD). Serão aplicadas automaticamente nas 24 cláusulas do contrato.",
      contractHint: "A assinatura aparece no contrato em PDF e ele fica armazenado automaticamente no perfil do cliente.",
      contractStored: "Contrato assinado armazenado",
      contractStoredHint: "PDF arquivado no perfil do cliente. Você pode reabrir ou baixar a qualquer momento.",
      versionsSaved: "versão(ões)",
      langBannerTitle: "Idioma do contrato",
      langBannerHint: "Escolha o idioma — o PDF gerado e armazenado ao assinar será nesse idioma.",
    },
    contracts: {
      title: "Contratos assinados",
      subtitle: "Todos os contratos PDF assinados por este cliente ficam armazenados aqui.",
      empty: "Nenhum contrato assinado ainda. Quando o cliente assinar um aluguel, o PDF aparecerá aqui automaticamente.",
      view: "Ver",
      download: "Baixar",
      send: "Enviar",
    },
    share: {
      title: "Enviar contrato ao cliente",
      generating: "Gerando link seguro...",
      publicLink: "Link público temporário",
      copy: "Copiar",
      linkCopied: "Link copiado",
      expiresIn: "Expira em {{days}} dias · acessível por qualquer pessoa com o link",
      viaWhatsapp: "Enviar pelo WhatsApp",
      viaEmail: "Enviar por Email",
      noPhone: "Cliente sem telefone",
      noEmail: "Cliente sem email",
      previewMessage: "Mensagem prévia",
      securityNote: "🔒 O link expira automaticamente. Você pode revogar a qualquer momento gerando um novo.",
    },
    wizard: {
      title: "Novo aluguel",
      stepN: "Passo {{n}} de {{total}}",
      change: "Trocar",
      cancelConfirm: "Cancelar o aluguel? Os dados não salvos serão perdidos.",
      rentalCreated: "Aluguel criado · agora preencha a vistoria",
      completed: "Aluguel finalizado",
      completedWithContract: "Aluguel finalizado · contrato armazenado no perfil do cliente",
      steps: {
        customer:  { label: "Etapa 1", short: "Cliente",   heading: "Quem está alugando?",           description: "Selecione um cliente existente ou cadastre um novo na hora." },
        car:       { label: "Etapa 2", short: "Veículo",   heading: "Qual carro vai sair?",          description: "Toque no veículo disponível para esta locação." },
        period:    { label: "Etapa 3", short: "Período",   heading: "Quando e quanto?",              description: "Defina datas, modalidade de cobrança, caução e idioma do contrato." },
        checklist: { label: "Etapa 4", short: "Vistoria",  heading: "Inspeção de entrega",           description: "Marque os 12 itens, ajuste combustível e hodômetro." },
        photos:    { label: "Etapa 5", short: "Fotos",     heading: "Fotos do estado do carro",       description: "Documente exterior, interior e detalhes antes da entrega." },
        signature: { label: "Etapa 6", short: "Contrato",  heading: "Revisar e assinar",             description: "Mostre o resumo ao cliente, escolha o idioma e colete a assinatura." },
      },
      customer: { searchPlaceholder: "Buscar por nome, telefone, CNH ou email...", new: "Novo cliente", newTitle: "Cadastrar cliente", created: "Cliente cadastrado", empty: "Nenhum cliente encontrado." },
      car: { empty: "Nenhum carro disponível no momento. Libere um veículo na Frota antes de continuar." },
      period: { summary: "Resumo do período", unitRate: "Valor unitário", qty: "Qtd cobrada", contractLang: "Idioma do contrato", contractLangHint: "Pré-selecione o idioma. Você poderá ajustar antes da assinatura." },
      photos: { hint: "As fotos serão anexadas a este aluguel e ficarão disponíveis na devolução para comparação." },
      signature: { reviewTitle: "Resumo final · confirme com o cliente", finalize: "Concluir e arquivar contrato" },
    },
    today: {
      pageTitle: "Operação do dia",
      subtitle: "Tudo que importa esta manhã: retiradas, devoluções, atrasos e alertas.",
      refresh: "Atualizar",
      kpis: { pickupsToday: "Retiradas hoje", returnsToday: "Devoluções hoje", overdue: "Atrasados", alerts: "Alertas" },
      returnsToday: "Devoluções de hoje",
      pickupsToday: "Retiradas de hoje",
      overdue: "Aluguéis em atraso",
      compliance: "Documentação vencendo",
      compliance_kind: { insurance: "Seguro", inspection: "Inspeção MA", registration: "Registration" },
      maintenance: "Manutenção próxima (7d)",
      recap: "Resumo financeiro",
      yesterdayRevenue: "Receita de ontem",
      weekRevenue: "Receita 7 dias",
      payments: "pagamentos",
      last7days: "Últimos 7 dias",
      empty: {
        returns: "Sem devoluções previstas hoje.",
        pickups: "Sem retiradas previstas hoje.",
        overdue: "Tudo em dia ✓",
        compliance: "Nenhum vencimento próximo ✓",
        maintenance: "Sem manutenções agendadas nos próximos 7 dias.",
      },
      expiredAgo: "atrás",
      left: "restantes",
    },
    checklist: {
      titlePickup: "Vistoria de entrega",
      titleReturn: "Vistoria de devolução",
      saved: "Vistoria salva",
      fuelLevel: "Nível de combustível",
      odometer: "Hodômetro (mi)",
      notesPlaceholder: "Observações da vistoria, danos identificados...",
      completedAt: "Concluída em",
      items: {
        exterior_clean: "Exterior limpo",
        interior_clean: "Interior limpo",
        no_damage_body: "Sem danos na lataria",
        no_damage_glass: "Sem danos em vidros/espelhos",
        tires_ok: "Pneus em bom estado",
        spare_tire: "Estepe + macaco",
        all_lights_ok: "Faróis e luzes ok",
        wipers_ok: "Limpador de para-brisa ok",
        documents_present: "Documentos do veículo",
        key_count_ok: "Chaves completas",
        manual_present: "Manual presente",
        registration_present: "Registration card",
      },
    },
    contract: {
      openPdf: "Contrato em PDF",
      storeInLang: "Salvar em {{lang}}",
      generated: "Contrato em {{lang}} gerado e arquivado no perfil do cliente",
    },
    bi: {
      pageTitle: "Inteligência de negócio",
      pageSubtitle: "ROI por veículo, previsão de receita e taxa de ocupação da frota.",
      totalRevenue: "Receita total",
      totalProfit: "Lucro total",
      expenses: "Despesas",
      occupancy: "Ocupação média",
      fleetSize: "Tamanho da frota",
      activeRentals: "{{n}} contratos ativos",
      last90days: "Últimos 90 dias",
      healthy: "Operação saudável",
      atRisk: "Atenção · receita < custos",
      forecastTitle: "Previsão",
      forecastSubtitle: "Receita real × projeção (30/60/90 dias)",
      avgDaily: "Média diária",
      actual30: "Real 30d",
      actual60: "Real 60d",
      actual90: "Real 90d",
      projected30: "Projeção 30d",
      projected60: "Projeção 60d",
      projected90: "Projeção 90d",
      amount: "Valor",
      fleetPerformance: "Desempenho da frota",
      fleetPerformanceSubtitle: "ROI e ocupação por veículo",
      vehicles: "veículos",
      noVehicles: "Cadastre veículos para ver o desempenho.",
      vehicle: "Veículo",
      rentals: "Aluguéis",
      revenue: "Receita",
      profit: "Lucro",
      roi: "ROI",
      occupancyShort: "Ocupação (90d)",
      topEarners: "Top performers",
      profitPerCar: "Lucro por veículo",
    },
    maintenanceV2: {
      pageTitle: "Manutenção & Frota",
      pageSubtitle: "Serviços agendados, histórico completo e registro de acidentes.",
      tabs: { services: "Serviços", history: "Histórico", accidents: "Acidentes" },
      addService: "Adicionar serviço",
      addAccident: "Registrar acidente",
      serviceType: "Tipo de serviço",
      lastDoneDate: "Última vez (data)",
      lastDoneMiles: "Última vez (milhas)",
      intervalMiles: "Intervalo (milhas)",
      intervalMonths: "Intervalo (meses)",
      intervalMilesHint: "Ex: 5000",
      intervalMonthsHint: "Ex: 6",
      daysLeft: "Dias restantes",
      milesLeft: "Milhas restantes",
      last: "Última",
      markPerformed: "Marcar como feito",
      performTitle: "Marcar {{name}} como executado",
      servicePerformed: "Serviço registrado · próxima data recalculada",
      serviceCreated: "Serviço adicionado",
      serviceDeleted: "Serviço removido",
      confirmDeleteService: "Remover este serviço?",
      emptyServices: "Sem serviços ativos",
      emptyServicesSub: "Adicione serviços como troca de óleo, pneus e freios para receber alertas automáticos.",
      emptyAccidents: "Nenhum acidente registrado",
      accidentCreated: "Acidente registrado",
      accidentDeleted: "Acidente removido",
      confirmDeleteAccident: "Remover este registro?",
      incidentDate: "Data do incidente",
      estimatedCost: "Custo estimado",
      policeReport: "Boletim de ocorrência",
      insuranceClaim: "Reclamação seguro #",
      thirdPartyInfo: "Terceiros envolvidos",
      thirdPartyHint: "Nome / placa / seguro do outro envolvido (se houver)",
      types: {
        oil_change: "Troca de óleo",
        tire_rotation: "Rodízio de pneus",
        tire_replacement: "Troca de pneus",
        brakes: "Freios",
        ma_inspection: "Inspeção MA",
        alignment: "Alinhamento",
        transmission_fluid: "Fluido de transmissão",
        battery: "Bateria",
        other: "Outro",
      },
      severity: { overdue: "Vencido", soon: "Em breve", ok: "OK" },
      accidentStatus: { open: "Aberto", in_review: "Em análise", closed: "Fechado" },
    },
    tickets: {
      pageTitle: "Multas · {{n}} registros · {{total}}",
      pageSubtitle: "Multas e citações vinculadas automaticamente ao aluguel ativo na data.",
      newTicket: "Nova multa",
      citationNumber: "Número da multa",
      issueDatetime: "Data/hora da infração",
      amount: "Valor",
      type: "Tipo",
      issuer: "Órgão emissor",
      location: "Local",
      plateOnTicket: "Placa (override opcional)",
      plateHint: "Se diferente do veículo selecionado",
      selectCarHint: "Auto-detectar pela placa",
      selectCarRequired: "Selecione o veículo *",
      carRequired: "Selecione o veículo antes de salvar.",
      createdNoActiveRental: "Multa registrada — sem aluguel ativo nesta data (cobrança avulsa)",
      autoChargeHint: "Cobrar automaticamente do cliente (desconta do caução do aluguel detectado)",
      notLinked: "Não vinculado",
      markPaid: "Marcar como paga",
      markedPaid: "Multa marcada como paga",
      created: "Multa registrada",
      createdAutoLinked: "Multa registrada e vinculada ao aluguel ativo automaticamente",
      deleted: "Multa removida",
      confirmDelete: "Excluir esta multa?",
      emptyTitle: "Nenhuma multa registrada",
      emptySub: "As multas aparecerão aqui assim que registradas e serão vinculadas automaticamente aos clientes.",
      types: {
        parking: "Estacionamento",
        speeding: "Velocidade",
        red_light: "Sinal vermelho",
        toll_violation: "Pedágio (sem pagar)",
        registration: "Documentação",
        other: "Outra",
      },
      status: { pending: "Pendente", charged: "Cobrada", paid: "Paga" },
    },
    tolls: {
      pageTitle: "Pedágios · {{n}} registros · {{total}}",
      pageSubtitle: "Pedágios EZ-Pass e Pay-By-Plate. Vinculação automática ao aluguel ativo.",
      newToll: "Novo pedágio",
      datetime: "Data/hora",
      amount: "Valor",
      location: "Praça / Localização",
      importCsv: "Importar CSV",
      csvHintTitle: "Importação em massa do EZDriveMA",
      csvHintBody: "Exporte seu extrato mensal em CSV (data, valor, placa, local, transponder) e arraste aqui. O sistema vincula cada pedágio ao aluguel ativo na data/hora correspondente e cobra automaticamente.",
      ezpassTag: "EZPass / Transponder (opcional)",
      ezpassTagHint: "Ex: 02100123456789 — usado quando a placa não bate",
      importedN: "{{n}} pedágios importados · {{linked}} vinculados a aluguéis",
      autoChargeHint: "Cobrar automaticamente do cliente (desconta do caução)",
      created: "Pedágio registrado",
      createdAutoLinked: "Pedágio registrado e vinculado ao aluguel",
      deleted: "Pedágio removido",
      confirmDelete: "Excluir este pedágio?",
      linked: "Vinculado",
      unlinked: "Sem vínculo",
      emptyTitle: "Sem pedágios registrados",
      emptySub: "Importe um CSV do EZDriveMA ou registre um pedágio manualmente.",
      selectCarRequired: "Selecione o veículo *",
      carRequired: "Selecione o veículo antes de salvar.",
      createdNoActiveRental: "Pedágio registrado — sem aluguel ativo nesta data",
    },
    users: {
      pageTitle: "Usuários do Sistema ({{n}})",
      pageSubtitle: "Convide pessoas para acessar o sistema. Admins veem tudo; Operadores não veem Financeiro, BI, Atividade nem Usuários.",
      invite: "Convidar usuário",
      inviteTitle: "Convidar novo usuário",
      name: "Nome",
      email: "Email",
      phone: "WhatsApp",
      phoneE164: "WhatsApp (formato internacional)",
      phoneHint: "Inclua DDI e DDD. Ex: +15614556277 (EUA) ou +5511999998888 (Brasil)",
      role: "Função",
      roleAdmin: "Admin",
      roleOperator: "Operador",
      roleAdminHint: "Acesso total — pode ver tudo, configurar Stripe/Zelle e gerenciar usuários.",
      roleOperatorHint: "Acesso operacional — pode gerenciar frota, aluguéis, pedágios e pagamentos. Não vê Financeiro/BI/Atividade/Usuários.",
      whatsappHint: "Um link de convite (válido por 7 dias) será enviado via WhatsApp para a pessoa criar a senha.",
      sendInvite: "Enviar convite",
      inviteSent: "Convite enviado para {{name}} via WhatsApp",
      inviteCreatedNoWhatsapp: "Usuário criado, mas WhatsApp falhou: {{error}}",
      resendInvite: "Reenviar convite",
      resendOk: "Convite reenviado com sucesso",
      resendFailed: "Falha ao reenviar: {{error}}",
      statusActive: "Ativo",
      statusPending: "Aguardando aceite",
      statusInactive: "Desativado",
      activate: "Ativar",
      deactivate: "Desativar",
      you: "você",
      confirmDelete: "Remover {{name}} permanentemente?",
      deleted: "Usuário removido",
      emptyTitle: "Sem usuários ainda",
      emptySub: "Clique em \"Convidar usuário\" para adicionar alguém ao sistema.",
    },
    acceptInvite: {
      welcomeBadge: "Bem-vindo à Movix",
      helloName: "Olá, {{name}}!",
      bodyIntro: "Você foi convidado(a) para acessar o sistema como {{role}}. Crie sua senha abaixo para ativar seu acesso.",
      newPassword: "Nova senha",
      confirmPassword: "Confirmar senha",
      activate: "Ativar acesso",
      passwordTooShort: "Senha deve ter no mínimo 6 caracteres",
      passwordsDontMatch: "As senhas não coincidem",
      success: "Senha criada! Redirecionando para login...",
      successTitle: "Acesso ativado!",
      redirecting: "Redirecionando para a tela de login…",
      invalidTitle: "Convite inválido",
      backToLogin: "← Voltar ao login",
    },
    linkPreview: {
      checking: "Verificando aluguel vinculado…",
      willLink: "Será vinculado a:",
      noMatch: "Nenhum aluguel ativo encontrado",
      noMatchHint: "Sem aluguel ativo nesta data, este lançamento ficará como avulso (não cobrado de cliente).",
    },
    aiInspector: {
      title: "Inspeção por IA",
      subtitle: "Compara fotos da entrega com fotos da devolução usando Gemini Vision e detecta novos danos. Também lê o marcador de combustível.",
      runBtn: "Analisar com IA",
      analyzing: "Analisando…",
      completed: "Análise concluída",
      failed: "Falha na análise",
      empty: "Nenhuma análise ainda. Envie fotos de entrega e devolução para que a IA possa comparar.",
      confidence: "Confiança",
      suggestedCharge: "Cobrança sugerida",
      applyCharge: "Aplicar cobrança",
      applyChargeTotal: "Cobrar {{amount}} do caução",
      confirmApply: "Aplicar essa cobrança ao caução do cliente?",
      chargeApplied: "Cobrança aplicada ao aluguel",
      alreadyApplied: "Cobrança já aplicada",
      damages: "Danos detectados",
      modalTitle: "Análise IA concluída · revisar com o cliente",
      reviewLater: "Revisar depois",
      fuel: {
        title: "Marcador de combustível",
        pickup: "Entrega",
        return: "Devolução",
        missing: "Faltando",
        calc: "Tanque {{tank}} gal · ${{price}}/gal · cobrança {{charge}} (inclui taxa de serviço se >5% faltando)",
        damageLabel: "Danos",
        fuelLabel: "Combustível",
      },
      verdict: {
        no_new_damage: "Nenhum dano novo detectado",
        new_damage_detected: "Possíveis danos detectados",
        inconclusive: "Análise inconclusiva",
      },
    },
    returnReport: {
      title: "Relatório de Devolução",
      subtitle: "PDF oficial assinável combinando recibo, vistoria, análise IA, extras e assinatura do cliente. Prova legal vinculante (ESIGN Act + M.G.L. c. 110G) contra chargebacks.",
      deposit: "Caução pago",
      charges: "Cobranças extras",
      refund: "A reembolsar",
      due: "Cliente deve",
      previewPdf: "Pré-visualizar PDF",
      previewError: "Falha ao abrir o PDF. Tente novamente.",
      customerSignature: "Assinatura do cliente",
      signatureHint: "Mostre o PDF ao cliente no iPad. Ao assinar, o sistema gera e arquiva o documento final automaticamente.",
      signAndStore: "Assinar e arquivar",
      savedAndStored: "Relatório de devolução assinado e armazenado",
      storedTitle: "Versões arquivadas",
      closingTitle: "Fechamento detalhado",
      milesAtPickup: "Milhas na entrega",
      milesAtReturn: "Milhas na devolução",
      milesDriven: "Milhas rodadas",
      lastLocation: "Última localização",
      tollsTitle: "Pedágios deste aluguel",
      ticketsTitle: "Multas deste aluguel",
      noTolls: "Nenhum pedágio registrado neste aluguel.",
      noTickets: "Nenhuma multa registrada neste aluguel.",
    },
    dangerZone: {
      title: "Zona de Perigo",
      description: "Zerar todos os dados operacionais do sistema. Use somente em casos de teste ou início de operação real.",
      wipeList1: "Todos os veículos, clientes, aluguéis e pagamentos",
      wipeList2: "Todos os pedágios, multas, manutenções e contratos",
      wipeList3: "Histórico de atividades, fotos e inspeções IA",
      preservedNote: "✓ PRESERVADO: Usuários do sistema (admin/operadores) e configurações (Stripe, Twilio, Zelle, PIX).",
      wipeButton: "Zerar Dados Operacionais",
      confirmTitle: "Esta ação NÃO pode ser desfeita.",
      typePhrase: "Digite para confirmar:",
      confirmWipe: "Confirmar Zeragem",
      success: "{{n}} registros apagados. Sistema zerado.",
      wrongPhrase: "Frase de confirmação errada. Digite exatamente: ZERAR TUDO",
    },
    profile: {
    ownerSignature: {
      title: "Assinatura do Proprietário",
      description: "Esta assinatura será gravada uma vez e usada automaticamente em todos os recibos de pagamento gerados (em PT, EN ou ES, conforme o idioma do cliente).",
      ownerName: "Nome do proprietário",
      ownerTitle: "Cargo (opcional)",
      titlePlaceholder: "Ex: Proprietário, Diretor, Gerente",
      defaultTitle: "Proprietário",
      drawHere: "Desenhe aqui sua assinatura →",
      clear: "Limpar",
      save: "Salvar Assinatura",
      saved: "Assinatura salva — será usada em todos os recibos",
      remove: "Remover",
      removed: "Assinatura removida",
      confirmRemove: "Remover a assinatura? Recibos futuros não terão assinatura.",
      redraw: "Refazer",
      updateNames: "Salvar nomes",
      nameRequired: "Informe o nome do proprietário",
      signatureRequired: "Desenhe sua assinatura antes de salvar",
    },
      pageTitle: "Perfil",
      pageSubtitle: "Atualize suas informações e altere sua senha.",
      accountInfo: "Dados da conta",
      email: "E-mail",
      role: "Função",
      name: "Nome",
      profileUpdated: "Perfil atualizado",
      changePassword: "Alterar senha",
      currentPassword: "Senha atual",
      newPassword: "Nova senha",
      confirmPassword: "Confirmar nova senha",
      passwordsDontMatch: "As senhas não coincidem",
      passwordTooShort: "A senha deve ter pelo menos 6 caracteres",
      passwordChanged: "Senha alterada com sucesso. Use a nova no próximo login.",
      updatePassword: "Atualizar senha",
      passwordTips: "Dica: use pelo menos 8 caracteres com letras maiúsculas, números e símbolos.",
      strength: { weak: "Fraca", fair: "Razoável", good: "Boa", strong: "Forte" },
      paymentTitle: "Pagamentos (Zelle / PIX)",
      paymentSubtitle: "Estes dados serão incluídos automaticamente em toda cobrança enviada por WhatsApp. Zelle não tem API pública — o cliente paga direto pelo app do banco usando seu email ou telefone.",
      paymentSaved: "Dados de pagamento salvos",
      zelleEmail: "Email Zelle",
      zellePhone: "Telefone Zelle",
      zelleAccountName: "Nome do beneficiário (no banco)",
      pixKey: "Chave PIX (clientes Brasil — opcional)",
      zelleQrTitle: "QR Code Zelle (opcional)",
      zelleQrHint: "Abra o app do seu banco (Chase, BofA, Wells Fargo...) → Zelle → 'Generate QR' → tire um print → suba aqui. O QR será incluído nas cobranças.",
      uploadQr: "Subir QR Code",
      removeQr: "Remover",
      qrUploaded: "QR Code salvo",
      qrRemoved: "QR Code removido",
      confirmRemoveQr: "Remover o QR Code do Zelle?",
      savePayment: "Salvar dados de pagamento",
      remindersTitle: "Lembretes automáticos por WhatsApp",
      remindersHint: "Todo dia às 9h (horário leste), o sistema envia automaticamente WhatsApp aos clientes que: (1) têm pagamento vencendo HOJE ou AMANHÃ, ou (2) estão atrasados. Cada cliente recebe no máximo 1 mensagem por dia por estado — sem spam.",
      runRemindersNow: "Disparar agora (teste)",
      remindersDispatched: "✅ {{n}} lembrete(s) enviado(s)",
      remindersFailed: "Falha ao disparar lembretes",
      statSent: "Enviados",
      statDedup: "Já enviados",
      statNoPhone: "Sem fone",
      statErrors: "Erros",
      recentReminders: "Últimos lembretes",
      sandboxWarningTitle: "Ambiente de Testes Ativo",
      stripeSandboxLabel: "Stripe em SANDBOX",
      stripeSandboxMsg: "Pagamentos com cartão estão sendo simulados. Nenhum dinheiro real está caindo na sua conta. Substitua sua STRIPE_API_KEY por 'sk_live_...' antes de operar com clientes reais.",
      twilioSandboxLabel: "Twilio WhatsApp em SANDBOX",
      twilioSandboxMsg: "Mensagens são enviadas pelo número de teste {{from}}. O cliente precisa enviar 'join fell-usually' para esse número uma vez antes de receber. Solicite aprovação Meta para usar seu número Business.",
    },
    paymentStatus: {
      paid: "Pago",
      dueSoon: "A vencer",
      overdue: "Atrasado",
      unknown: "—",
      nextDue: "Próximo vencimento",
      nextIn: "vence em {{days}}d",
      upToDate: "em dia",
      today: "hoje",
      tomorrow: "amanhã",
      inDays: "em {{days}}d",
      daysLate: "{{days}}d em atraso",
    },
    collectionToday: {
      title: "COBRANÇA HOJE",
      subtitle: "{{n}} cliente(s) precisam ser cobrados · {{overdue}} em atraso",
      totalDue: "Total a receber",
      chargeZelle: "Cobrar Zelle",
      allClear: "Nenhuma cobrança pendente hoje 🎉",
      allClearHint: "Todos os aluguéis ativos estão em dia.",
      sentSuccess: "✅ Cobrança enviada automaticamente por WhatsApp",
      openOnWhatsapp: "Mensagem pronta — abrindo WhatsApp",
      noPhone: "Cliente sem telefone cadastrado",
    },
    activity: {
      pageTitle: "ATIVIDADE",
      heading: "Diário de Bordo",
      subtitle: "Linha do tempo completa do seu negócio · contabilidade & auditoria",
      totalEvents: "Total de eventos",
      totalRevenue: "Receita no período",
      rentalsCreated: "Aluguéis criados",
      paymentsReceived: "Pagamentos recebidos",
      empty: "Nenhuma atividade no período selecionado",
      emptyHint: "Ajuste os filtros ou crie um aluguel.",
      types: {
        rental: "Aluguéis",
        payment: "Pagamentos",
        customer: "Clientes",
        car: "Carros",
        reminder: "Lembretes",
        contract: "Documentos",
      },
    },
    quickRental: {
      title: "Alugar {{model}} ({{plate}})",
      subtitle: "Cadastre o cliente, defina datas e gere o contrato em segundos",
      customer: "Cliente",
      searchExisting: "Buscar cliente",
      newCustomer: "Novo cliente",
      searchPlaceholder: "Nome, telefone ou CNH...",
      noCustomers: "Nenhum cliente encontrado. Use 'Novo cliente' para cadastrar.",
      selectedClient: "Cliente selecionado",
      name: "Nome completo",
      phone: "Telefone (com DDI)",
      driverLicense: "CNH / Driver's License",
      email: "E-mail (opcional)",
      financials: "Datas e valores",
      pickup: "Data de retirada",
      return: "Data de devolução",
      weeklyRate: "Valor semanal ($)",
      deposit: "Caução ($)",
      depositLabel: "Caução",
      totalAtPickup: "Total a cobrar na entrega",
      period: { daily: "Diária", weekly: "Semanal", monthly: "Mensal" },
      rateLabel: {
        diaria: "Valor diário ($)",
        semanal: "Valor semanal ($)",
        mensal: "Valor mensal ($)",
      },
      duration: {
        diaria: "{{n}} dia(s)",
        semanal: "{{n}} semana(s)",
        mensal: "{{n}} mês(es)",
      },
      confirmAndPrint: "Confirmar e abrir contrato",
      created: "Aluguel criado! Abrindo contrato para impressão...",
      pdfFailed: "Aluguel criado, mas o contrato não pôde ser aberto. Acesse pelo aluguel.",
    },
  },

  en: {
    common: {
      loading: "Loading…",
      systemOnline: "SYSTEM ONLINE",
      cancel: "Cancel",
      save: "Save",
      edit: "Edit",
      delete: "Delete",
      add: "Add",
      search: "Search...",
      all: "All",
      total: "Total",
      status: "Status",
      date: "Date",
      description: "Description",
      amount: "Amount",
      value: "Value",
      notes: "Notes",
      none: "None",
      select: "Select...",
      confirmDelete: "Are you sure you want to delete?",
      sessionLabel: "Session",
      logout: "Logout",
      operations: "Operations",
      print: "Print",
      details: "Details",
      yes: "Yes",
      no: "No",
      never: "Never",
      open: "Open",
      back: "Back",
      next: "Next",
    },
    sidebar: {
      dashboard: "Dashboard",
      today: "Today",
      fleet: "Fleet",
      customers: "Customers",
      rentals: "Rentals",
      payments: "Payments",
      maintenance: "Maintenance",
      tickets: "Tickets",
      tolls: "Tolls",
      gps: "Tracking",
      financial: "Financials",
      billing: "Billing",
      bi: "Intelligence",
      activity: "Activity",
      users: "Users",
      profile: "Profile",
    },
    login: {
      restrictedAccess: "Restricted access",
      signIn: "Sign in to dashboard",
      useCredentials: "Use your administrative credentials.",
      email: "Email",
      password: "Password",
      submit: "Sign in",
      defaultCreds: "Default credentials",
      systemVersion: "Operating system · v1.0",
      heroTitle1: "Total command",
      heroTitle2: "over your fleet.",
      heroDescription: "Fleet, customers, contracts, payments, maintenance and GPS tracking — in a single sophisticated dashboard.",
      heroFooter: "ALL SYSTEMS NOMINAL",
      brandSub: "Operating system",
    },
    dashboard: {
      available: "Available",
      rented: "Rented",
      maintenance: "Maintenance",
      overdue: "Overdue",
      revenueMonth: "Revenue this month",
      revenueTotal: "Total revenue",
      profit: "Estimated profit",
      upcoming: "Returns in 7d",
      ofVehicles: "of {{n}} vehicles",
      activeContracts: "{{n}} active contracts",
      inWorkshop: "In workshop",
      overdueReturns: "Late returns",
      confirmedPayments: "Confirmed payments",
      accumulated: "Accumulated",
      expenses: "Expenses",
      scheduled: "{{n}} scheduled",
      revenue: "Revenue",
      last6months: "Last 6 months",
      fleet: "Fleet",
      currentStatus: "Current status",
      noData: "No data",
    },
    fleet: {
      pageTitle: "Fleet · {{n}} vehicles",
      pageSubtitle: "Manage your vehicles, status and operational info.",
      newCar: "New vehicle",
      registerCar: "Register vehicle",
      editCar: "Edit vehicle",
      model: "Model",
      plate: "Plate",
      year: "Year",
      color: "Color",
      dailyPrice: "Daily rate ($)",
      weeklyPrice: "Weekly rate ($)",
      monthlyPrice: "Monthly rate ($)",
      ratesTitle: "Pricing tiers",
      ratesHint: "Values auto-suggest when you change one — feel free to override.",
      weekShort: "wk",
      dailyAutoHint: "Auto daily: ${{rate}} (weekly ÷ 7)",
      unknownRenter: "Renter",
      dueOn: "Due",
      overdue: "overdue",
      today: "today",
      tomorrow: "tomorrow",
      pendingCharges: "Pending charges",
      mileage: "Mileage (mi)",
      gpsId: "GPS device ID",
      fuel: "Fuel type",
      photo: "Photo (URL)",
      insurancePolicy: "Insurance Policy",
      insuranceExpiry: "Insurance Expiry",
      maInspectionExpiry: "MA Inspection Expiry",
      registrationExpiry: "Registration Expiry",
      ezpassTag: "EZPass / Transponder",
      vin: "VIN (Chassis)",
      searchPlaceholder: "Search by plate, model, color, year...",
      noResults: "No results",
      tryDifferent: "Try different search terms.",
      sort: {
        newest: "Newest first",
        oldest: "Oldest first",
        plateAsc: "Plate (A→Z)",
        modelAsc: "Model (A→Z)",
        priceDesc: "Highest rate",
        priceAsc: "Lowest rate",
        mileageAsc: "Lowest mileage",
        mileageDesc: "Highest mileage",
      },
      emptyTitle: "Empty fleet",
      emptySub: "Register your first vehicle to get started.",
      registerFirst: "Register vehicle",
      rentNow: "Rent Now",
      status: {
        disponivel: "Available",
        alugado: "Rented",
        manutencao: "Maintenance",
      },
      created: "Vehicle created",
      updated: "Vehicle updated",
      deleted: "Vehicle deleted",
      confirmDelete: "Delete this vehicle?",
    },
    customers: {
      pageTitle: "Customers · {{n}} registered",
      pageSubtitle: "Full record with Social Security, Driver License and contact.",
      newCustomer: "New customer",
      registerCustomer: "Register customer",
      editCustomer: "Edit customer",
      fullName: "Full name",
      ssn: "Social Security (SSN)",
      license: "Driver License",
      phone: "Phone",
      email: "Email",
      address: "Address",
      preferredLanguage: "Preferred language (for receipts and WhatsApp)",
      preferredLanguageHint: "Receipts and automated messages will be generated in this language",
      emptyTitle: "No customers",
      emptySub: "Register customers to create rental contracts.",
      created: "Customer added",
      updated: "Customer updated",
      deleted: "Customer deleted",
      confirmDelete: "Delete customer?",
    },
    rentals: {
      pageTitle: "Rentals · {{n}} contracts",
      pageSubtitle: "Contracts, dates and status. Revenue calculated automatically.",
      newRental: "New rental",
      openEnded: "Open-ended",
      wizardBtn: "Quick new rental",
      editRental: "Edit rental",
      vehicle: "Vehicle",
      customer: "Customer",
      pickup: "Pickup",
      return: "Return",
      billingType: "Billing type",
      daily: "Daily",
      weekly: "Weekly",
      dailyRate: "Daily rate ($)",
      weeklyRate: "Weekly rate ($)",
      deposit: "Deposit ($)",
      rentalValue: "Rental amount",
      pickupTotal: "Total to collect at pickup",
      pickupHint: "Rental + Deposit · refundable",
      billing: "Billing",
      perDay: "/day",
      perWeek: "/week",
      paymentCol: "Payment",
      emptyTitle: "No contracts",
      emptySub: "Create a rental to start operating.",
      created: "Rental created",
      updated: "Rental updated",
      deleted: "Rental deleted",
      confirmDelete: "Delete rental?",
      detailsTitle: "Details, EZ-Pass and receipts",
      day: "day",
      days: "days",
      week: "week",
      weeks: "weeks",
      status: {
        agendado: "Scheduled",
        ativo: "Active",
        concluido: "Completed",
        cancelado: "Cancelled",
      },
    },
    payments: {
      pageTitle: "Payments · {{n}} records",
      pageSubtitle: "Received and pending per contract.",
      newPayment: "Record payment",
      contract: "Contract (rental)",
      amount: "Amount ($)",
      method: "Method",
      received: "Received",
      pending: "Pending",
      methods: {
        dinheiro: "Cash",
        pix: "PIX",
        zelle: "Zelle",
        cartao: "Card",
        transferencia: "Transfer",
      },
      status: {
        pago: "Paid",
        pendente: "Pending",
      },
      contractCol: "Contract",
      emptyTitle: "No payments",
      created: "Payment recorded",
      deleted: "Payment deleted",
      confirmDelete: "Delete payment?",
      downloadReceipt: "Download receipt PDF",
    },
    maintenance: {
      pageTitle: "Maintenance · {{n}} records · {{cost}} in expenses",
      pageSubtitle: "Service history per vehicle.",
      newMaintenance: "Record maintenance",
      newTitle: "New maintenance",
      serviceType: "Service type",
      servicePlaceholder: "E.g. Oil change, 20k mi service",
      cost: "Cost ($)",
      mileageAt: "Mileage at service",
      performedAt: "Performed on",
      nextAt: "Next service",
      optional: "optional",
      service: "Service",
      next: "Next",
      miles: "Miles",
      emptyTitle: "No maintenance records",
      created: "Maintenance recorded",
      deleted: "Maintenance deleted",
      confirmDelete: "Delete maintenance?",
    },
    gps: {
      pageTitle: "Tracking · {{n}} with GPS",
      pageSubtitle: "Last known location and manual coordinate updates. Live integration with a provider can be added later.",
      active: "Active",
      noGps: "No GPS",
      device: "Device",
      latitude: "Latitude",
      longitude: "Longitude",
      odometer: "Odometer",
      updated: "Updated",
      updateBtn: "Update",
      updateTitle: "Update location",
      odometerInput: "Odometer (mi)",
      hint: "Tip: paste Google Maps coordinates as lat, lng.",
      noVehicles: "No vehicles registered",
      locationUpdated: "Location updated",
    },
    financial: {
      pageTitle: "Financials",
      revenueTotal: "Total revenue",
      revenueMonth: "Revenue this month",
      expenses: "Expenses",
      profit: "Profit",
      monthlyRevenue: "Monthly revenue",
      last6: "Last 6 months",
      perVehicle: "Performance per vehicle",
      revenueVsCost: "Revenue × Costs",
      vehicle: "Vehicle",
      revenue: "Revenue",
      costs: "Costs",
    },
    receipt: {
      pickup: "Pickup receipt",
      return: "Return receipt",
      brand: "RENTALS",
      receiptNo: "Receipt #",
      pickupTitle: "PICKUP RECEIPT",
      returnTitle: "RETURN RECEIPT",
      issuedAt: "Issued on",
      customer: "Customer",
      vehicle: "Vehicle",
      period: "Rental period",
      pickupDate: "Pickup",
      returnDate: "Return",
      billing: "Billing",
      quantity: "Quantity",
      unitRate: "Unit rate",
      rentalValue: "Rental amount",
      pickupTotalSection: "Total due at pickup",
      rental: "Rental",
      depositRefundable: "Deposit (refundable)",
      totalPaid: "TOTAL PAID",
      pickupNote: "* The deposit of {{deposit}} will be refunded to the customer upon vehicle return, minus tolls (EZ-Pass), missing fuel, cleaning, damages and other extra charges.",
      tollsSection: "Deposit and extra charges",
      depositPaid: "Deposit paid at pickup",
      tollsTotal: "Extra charges total",
      noTolls: "No extra charges registered.",
      refundSection: "Amount refunded to customer",
      depositLine: "Deposit",
      tollsDeduct: "(−) Extra charges",
      refundedAmount: "REFUND AMOUNT",
      excessNote: "* Tolls exceed the deposit. Customer must pay {{excess}} additional.",
      signCustomer: "Customer",
      signCompany: "Company",
      responsible: "Authorized",
      eDoc: "Document issued electronically",
      ezpassCol: "Description",
    },
    rentalDetails: {
      depositLabel: "Deposit",
      ezpassTotal: "Extra charges total",
      depositMinus: "Deposit − Charges",
      pickupReceiptBtn: "Pickup receipt",
      returnReceiptBtn: "Return receipt",
      sendCheckinLink: "Customer check-in",
      checkinLinkCopied: "Check-in link copied",
      requestReview: "Ask Google review",
      reviewLinkCopied: "Link copied",
      ezpassSection: "Extra charges · deducted from deposit",
      placeholderToll: "E.g. GW Bridge",
      addToll: "Add",
      ezpassAdded: "Charge added",
      removed: "Removed",
      category: "Category",
      categories: {
        ezpass: "EZ-Pass / Toll",
        fuel: "Fuel",
        cleaning: "Cleaning",
        damage: "Damage",
        other: "Other",
      },
      placeholders: {
        ezpass: "E.g. GW Bridge",
        fuel: "E.g. Returned with empty tank (was full)",
        cleaning: "E.g. Deep interior cleaning",
        damage: "E.g. Scratch on front door",
        other: "E.g. Traffic ticket",
      },
      tabCharges: "Charges",
      tabPhotos: "Photos",
      tabChecklist: "Inspection",
      tabSignature: "Signature",
      tabReturnReport: "Return report",
    },
    billing: {
      chargeViaWhatsapp: "Charge via WhatsApp",
      linkGenerated: "Payment link generated",
      sentAutomatically: "✅ Billing sent automatically via WhatsApp",
      zelleOnly: "Charge via Zelle",
      zelleOnlyHint: "Send only Zelle/PIX details (no Stripe link)",
      zelleSentAutomatically: "✅ Zelle message sent automatically via WhatsApp",
      zelleMessageReady: "Zelle message ready",
      zelleReadyToSend: "Zelle billing ready",
      zelleQrShare: "Zelle QR Code will be shared with the customer",
      linkCopied: "Link copied",
      readyToSend: "Ready to send",
      openWhatsapp: "Open in WhatsApp",
      previewLink: "Preview link",
      copyLink: "Copy link",
      previewMessage: "Message that will be sent",
      noPhone: "Customer has no phone",
      paymentSuccess: "Payment confirmed!",
      paymentSuccessMsg: "Thank you. Your transaction was processed successfully.",
      paymentCancelled: "Payment cancelled",
      paymentCancelledMsg: "You can try again whenever you want.",
      backToApp: "Back to dashboard",
      checkingStatus: "Checking payment status…",
    },
    billingPage: {
      title: "Scheduled billing · {{n}} contracts",
      subtitle: "Weekly rentals with billing due in the next 48h or already overdue.",
      emptyTitle: "All clear",
      emptySub: "No pending billings in the next few days.",
      dueIn: "Due in",
      overdueBy: "Overdue by",
    },
    photos: {
      uploadBtn: "Upload photos",
      dropHint: "Drag photos here or click to select (up to 8MB each)",
      empty: "No photos uploaded yet.",
      uploadedN: "{{n}} file(s) uploaded",
      deleted: "Photo removed",
      confirmDelete: "Remove this photo?",
      carPhotos: "Vehicle gallery",
      carPhotosHint: "Official car photos: exterior, interior, dashboard, odometer.",
      pickupCondition: "Pickup condition",
      pickupConditionHint: "Document the vehicle condition at pickup time.",
      returnCondition: "Return condition",
      returnConditionHint: "Document the condition and any damages upon return.",
      customerDocs: "Customer documents",
      customerDocsHint: "Driver License, Social Security or other documents. PDF and images accepted.",
    },
    signature: {
      title: "Customer digital signature",
      hint: "Use mouse or touch",
      placeholder: "SIGN HERE",
      clear: "Clear",
      save: "Save signature",
      saved: "Signature saved",
      savedAndStored: "Signature saved and contract stored in the customer profile",
      emptyError: "Please sign before saving.",
      remove: "Remove",
      removed: "Signature removed",
      confirmRemove: "Remove the signature?",
      signedOn: "Signed at",
      initialsLabel: "Initials",
      initialsHint: "Type the customer initials (e.g. JD). They will be auto-applied to all 24 clauses of the contract.",
      contractHint: "The signature appears in the PDF contract and the PDF is automatically stored in the customer profile.",
      contractStored: "Signed contract stored",
      contractStoredHint: "PDF archived in the customer profile. You can reopen or download it anytime.",
      versionsSaved: "version(s)",
    },
    contracts: {
      title: "Signed contracts",
      subtitle: "Every PDF contract signed by this customer is archived here.",
      empty: "No signed contracts yet. As soon as the customer signs a rental, the PDF will appear here automatically.",
      view: "View",
      download: "Download",
      send: "Send",
    },
    share: {
      title: "Send contract to customer",
      generating: "Generating secure link...",
      publicLink: "Temporary public link",
      copy: "Copy",
      linkCopied: "Link copied",
      expiresIn: "Expires in {{days}} days · accessible to anyone with the link",
      viaWhatsapp: "Send via WhatsApp",
      viaEmail: "Send via Email",
      noPhone: "Customer has no phone",
      noEmail: "Customer has no email",
      previewMessage: "Message preview",
      securityNote: "🔒 The link expires automatically. You can revoke it anytime by generating a new one.",
    },
    wizard: {
      title: "New rental",
      stepN: "Step {{n}} of {{total}}",
      change: "Change",
      cancelConfirm: "Cancel rental? Unsaved data will be lost.",
      rentalCreated: "Rental created · now fill in the inspection",
      completed: "Rental finalized",
      completedWithContract: "Rental finalized · contract stored in customer profile",
      steps: {
        customer:  { label: "Step 1", short: "Customer",  heading: "Who is renting?",                description: "Pick an existing customer or create one on the fly." },
        car:       { label: "Step 2", short: "Vehicle",   heading: "Which vehicle goes out?",        description: "Tap the available car for this rental." },
        period:    { label: "Step 3", short: "Period",    heading: "When and how much?",             description: "Set dates, billing mode, deposit and contract language." },
        checklist: { label: "Step 4", short: "Inspection",heading: "Pickup inspection",              description: "Tick the 12 items, set fuel level and odometer." },
        photos:    { label: "Step 5", short: "Photos",    heading: "Vehicle condition photos",       description: "Document exterior, interior and details before handing over." },
        signature: { label: "Step 6", short: "Contract",  heading: "Review and sign",                description: "Show the summary, choose the language and collect the signature." },
      },
      customer: { searchPlaceholder: "Search by name, phone, license or email...", new: "New customer", newTitle: "Create customer", created: "Customer created", empty: "No customers found." },
      car: { empty: "No available cars right now. Release a vehicle in the Fleet before continuing." },
      period: { summary: "Period summary", unitRate: "Unit rate", qty: "Billed qty", contractLang: "Contract language", contractLangHint: "Pre-select the language. You can change it before signing." },
      photos: { hint: "Photos are attached to this rental and will be visible on return for comparison." },
      signature: { reviewTitle: "Final summary · confirm with the customer", finalize: "Finalize and archive contract" },
    },
    today: {
      pageTitle: "Today's operations",
      subtitle: "Everything that matters this morning: pickups, returns, overdues and alerts.",
      refresh: "Refresh",
      kpis: { pickupsToday: "Pickups today", returnsToday: "Returns today", overdue: "Overdue", alerts: "Alerts" },
      returnsToday: "Today's returns",
      pickupsToday: "Today's pickups",
      overdue: "Overdue rentals",
      compliance: "Expiring documents",
      compliance_kind: { insurance: "Insurance", inspection: "MA Inspection", registration: "Registration" },
      maintenance: "Maintenance due (7d)",
      recap: "Financial recap",
      yesterdayRevenue: "Yesterday revenue",
      weekRevenue: "7-day revenue",
      payments: "payments",
      last7days: "Last 7 days",
      empty: {
        returns: "No returns scheduled today.",
        pickups: "No pickups scheduled today.",
        overdue: "All clear ✓",
        compliance: "No upcoming expirations ✓",
        maintenance: "No maintenance scheduled in the next 7 days.",
      },
      expiredAgo: "ago",
      left: "left",
    },
    checklist: {
      titlePickup: "Pickup inspection",
      titleReturn: "Return inspection",
      saved: "Inspection saved",
      fuelLevel: "Fuel level",
      odometer: "Odometer (mi)",
      notesPlaceholder: "Inspection notes, identified damages...",
      completedAt: "Completed at",
      items: {
        exterior_clean: "Exterior clean",
        interior_clean: "Interior clean",
        no_damage_body: "No body damage",
        no_damage_glass: "No glass/mirror damage",
        tires_ok: "Tires in good condition",
        spare_tire: "Spare tire + jack",
        all_lights_ok: "Headlights & signals ok",
        wipers_ok: "Wipers ok",
        documents_present: "Vehicle documents",
        key_count_ok: "All keys present",
        manual_present: "Owner manual",
        registration_present: "Registration card",
      },
    },
    contract: {
      openPdf: "Contract PDF",
      storeInLang: "Save in {{lang}}",
      generated: "Contract in {{lang}} generated and archived in customer profile",
    },
    bi: {
      pageTitle: "Business intelligence",
      pageSubtitle: "Per-car ROI, revenue forecast and fleet occupancy.",
      totalRevenue: "Total revenue",
      totalProfit: "Total profit",
      expenses: "Expenses",
      occupancy: "Avg occupancy",
      fleetSize: "Fleet size",
      activeRentals: "{{n}} active rentals",
      last90days: "Last 90 days",
      healthy: "Healthy operation",
      atRisk: "Attention · revenue < costs",
      forecastTitle: "Forecast",
      forecastSubtitle: "Actual revenue × projection (30/60/90 days)",
      avgDaily: "Daily avg",
      actual30: "Actual 30d",
      actual60: "Actual 60d",
      actual90: "Actual 90d",
      projected30: "Projected 30d",
      projected60: "Projected 60d",
      projected90: "Projected 90d",
      amount: "Amount",
      fleetPerformance: "Fleet performance",
      fleetPerformanceSubtitle: "ROI and occupancy per vehicle",
      vehicles: "vehicles",
      noVehicles: "Add vehicles to see performance.",
      vehicle: "Vehicle",
      rentals: "Rentals",
      revenue: "Revenue",
      profit: "Profit",
      roi: "ROI",
      occupancyShort: "Occupancy (90d)",
      topEarners: "Top performers",
      profitPerCar: "Profit per vehicle",
    },
    maintenanceV2: {
      pageTitle: "Maintenance & Fleet",
      pageSubtitle: "Scheduled services, full history and accident records.",
      tabs: { services: "Services", history: "History", accidents: "Accidents" },
      addService: "Add service",
      addAccident: "Record accident",
      serviceType: "Service type",
      lastDoneDate: "Last done (date)",
      lastDoneMiles: "Last done (miles)",
      intervalMiles: "Interval (miles)",
      intervalMonths: "Interval (months)",
      intervalMilesHint: "e.g. 5000",
      intervalMonthsHint: "e.g. 6",
      daysLeft: "Days left",
      milesLeft: "Miles left",
      last: "Last",
      markPerformed: "Mark as done",
      performTitle: "Mark {{name}} as performed",
      servicePerformed: "Service logged · next due recalculated",
      serviceCreated: "Service added",
      serviceDeleted: "Service removed",
      confirmDeleteService: "Remove this service?",
      emptyServices: "No active services",
      emptyServicesSub: "Add services like oil change, tires and brakes to get automatic alerts.",
      emptyAccidents: "No accidents recorded",
      accidentCreated: "Accident recorded",
      accidentDeleted: "Accident removed",
      confirmDeleteAccident: "Remove this record?",
      incidentDate: "Incident date",
      estimatedCost: "Estimated cost",
      policeReport: "Police report #",
      insuranceClaim: "Insurance claim #",
      thirdPartyInfo: "Third party involved",
      thirdPartyHint: "Name / plate / insurance of the other party (if any)",
      types: {
        oil_change: "Oil change",
        tire_rotation: "Tire rotation",
        tire_replacement: "Tire replacement",
        brakes: "Brakes",
        ma_inspection: "MA Inspection",
        alignment: "Alignment",
        transmission_fluid: "Transmission fluid",
        battery: "Battery",
        other: "Other",
      },
      severity: { overdue: "Overdue", soon: "Due soon", ok: "OK" },
      accidentStatus: { open: "Open", in_review: "In review", closed: "Closed" },
    },
    tickets: {
      pageTitle: "Tickets · {{n}} records · {{total}}",
      pageSubtitle: "Citations auto-linked to the rental active at issue time.",
      newTicket: "New ticket",
      citationNumber: "Citation #",
      issueDatetime: "Issue date/time",
      amount: "Amount",
      type: "Type",
      issuer: "Issuing agency",
      location: "Location",
      plateOnTicket: "Plate (override)",
      plateHint: "If different from selected car",
      selectCarHint: "Auto-detect by plate",
      selectCarRequired: "Select vehicle *",
      carRequired: "Select the vehicle before saving.",
      createdNoActiveRental: "Ticket recorded — no active rental on this date (standalone charge)",
      autoChargeHint: "Automatically charge the customer (deducted from rental deposit)",
      notLinked: "Not linked",
      markPaid: "Mark as paid",
      markedPaid: "Ticket marked as paid",
      created: "Ticket recorded",
      createdAutoLinked: "Ticket recorded and auto-linked to the active rental",
      deleted: "Ticket removed",
      confirmDelete: "Delete this ticket?",
      emptyTitle: "No tickets recorded",
      emptySub: "Tickets will appear here once recorded and auto-link to customers.",
      types: {
        parking: "Parking",
        speeding: "Speeding",
        red_light: "Red light",
        toll_violation: "Toll violation",
        registration: "Registration",
        other: "Other",
      },
      status: { pending: "Pending", charged: "Charged", paid: "Paid" },
    },
    tolls: {
      pageTitle: "Tolls · {{n}} records · {{total}}",
      pageSubtitle: "EZ-Pass and Pay-By-Plate tolls. Auto-linked to active rental.",
      newToll: "New toll",
      datetime: "Date/time",
      amount: "Amount",
      location: "Plaza / Location",
      importCsv: "Import CSV",
      csvHintTitle: "Bulk import from EZDriveMA",
      csvHintBody: "Export your monthly EZDriveMA statement as CSV (date, amount, plate, location, transponder) and drop it here. The system links each toll to the active rental at the matching date/time and charges automatically.",
      ezpassTag: "EZPass / Transponder (optional)",
      ezpassTagHint: "Ex: 02100123456789 — used when plate doesn't match",
      importedN: "{{n}} tolls imported · {{linked}} linked to rentals",
      autoChargeHint: "Automatically charge the customer (deducted from deposit)",
      created: "Toll recorded",
      createdAutoLinked: "Toll recorded and linked to the rental",
      deleted: "Toll removed",
      confirmDelete: "Delete this toll?",
      linked: "Linked",
      unlinked: "Unlinked",
      emptyTitle: "No tolls recorded",
      emptySub: "Import an EZDriveMA CSV or add a toll manually.",
      selectCarRequired: "Select vehicle *",
      carRequired: "Select the vehicle before saving.",
      createdNoActiveRental: "Toll recorded — no active rental on this date",
    },
    users: {
      pageTitle: "System Users ({{n}})",
      pageSubtitle: "Invite people to access the system. Admins see everything; Operators don't see Financials, BI, Activity or Users.",
      invite: "Invite user",
      inviteTitle: "Invite a new user",
      name: "Name",
      email: "Email",
      phone: "WhatsApp",
      phoneE164: "WhatsApp (international format)",
      phoneHint: "Include country code. e.g. +15614556277 (US) or +5511999998888 (BR)",
      role: "Role",
      roleAdmin: "Admin",
      roleOperator: "Operator",
      roleAdminHint: "Full access — can see everything, set up Stripe/Zelle and manage users.",
      roleOperatorHint: "Day-to-day access — can manage fleet, rentals, tolls and payments. Cannot see Financials/BI/Activity/Users.",
      whatsappHint: "An invite link (valid for 7 days) will be sent via WhatsApp so the person can create their password.",
      sendInvite: "Send invite",
      inviteSent: "Invite sent to {{name}} via WhatsApp",
      inviteCreatedNoWhatsapp: "User created, but WhatsApp failed: {{error}}",
      resendInvite: "Resend invite",
      resendOk: "Invite resent successfully",
      resendFailed: "Resend failed: {{error}}",
      statusActive: "Active",
      statusPending: "Pending",
      statusInactive: "Disabled",
      activate: "Activate",
      deactivate: "Deactivate",
      you: "you",
      confirmDelete: "Permanently remove {{name}}?",
      deleted: "User removed",
      emptyTitle: "No users yet",
      emptySub: "Click \"Invite user\" to add someone to the system.",
    },
    acceptInvite: {
      welcomeBadge: "Welcome to Movix",
      helloName: "Hi, {{name}}!",
      bodyIntro: "You've been invited to access the system as {{role}}. Create your password below to activate access.",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      activate: "Activate access",
      passwordTooShort: "Password must be at least 6 characters",
      passwordsDontMatch: "Passwords don't match",
      success: "Password set! Redirecting to login...",
      successTitle: "Access activated!",
      redirecting: "Redirecting to login screen…",
      invalidTitle: "Invalid invite",
      backToLogin: "← Back to login",
    },
    linkPreview: {
      checking: "Checking linked rental…",
      willLink: "Will be linked to:",
      noMatch: "No active rental found",
      noMatchHint: "Without an active rental at this date, this entry will be standalone (no customer charge).",
    },
    aiInspector: {
      title: "AI Inspection",
      subtitle: "Compares pickup vs return photos with Gemini Vision and flags new damage. Also reads the fuel gauge.",
      runBtn: "Analyze with AI",
      analyzing: "Analyzing…",
      completed: "Analysis complete",
      failed: "Analysis failed",
      empty: "No analysis yet. Upload pickup and return photos so AI can compare them.",
      confidence: "Confidence",
      suggestedCharge: "Suggested charge",
      applyCharge: "Apply charge",
      applyChargeTotal: "Charge {{amount}} from deposit",
      confirmApply: "Apply this charge against the customer deposit?",
      chargeApplied: "Charge applied to the rental",
      alreadyApplied: "Charge already applied",
      damages: "Detected damages",
      modalTitle: "AI analysis ready · review with the customer",
      reviewLater: "Review later",
      fuel: {
        title: "Fuel gauge",
        pickup: "Pickup",
        return: "Return",
        missing: "Missing",
        calc: "{{tank}} gal tank · ${{price}}/gal · charge {{charge}} (includes service fee when >5% missing)",
        damageLabel: "Damage",
        fuelLabel: "Fuel",
      },
      verdict: {
        no_new_damage: "No new damage detected",
        new_damage_detected: "Potential new damage detected",
        inconclusive: "Inconclusive analysis",
      },
    },
    returnReport: {
      title: "Return Report",
      subtitle: "Official signable PDF combining receipt, inspection, AI analysis, extras and customer signature. Legally binding evidence (ESIGN Act + M.G.L. c. 110G) against chargebacks.",
      deposit: "Deposit paid",
      charges: "Extra charges",
      refund: "Refund",
      due: "Customer owes",
      previewPdf: "Preview PDF",
      previewError: "Failed to open PDF. Try again.",
      customerSignature: "Customer signature",
      signatureHint: "Show the PDF to the customer on the iPad. After signing, the final document is generated and archived automatically.",
      signAndStore: "Sign & archive",
      savedAndStored: "Return report signed and stored",
      storedTitle: "Archived versions",
      closingTitle: "Detailed closing breakdown",
      milesAtPickup: "Miles at pickup",
      milesAtReturn: "Miles at return",
      milesDriven: "Miles driven",
      lastLocation: "Last GPS location",
      tollsTitle: "Tolls during this rental",
      ticketsTitle: "Tickets during this rental",
      noTolls: "No tolls recorded for this rental.",
      noTickets: "No tickets recorded for this rental.",
    },
    dangerZone: {
      title: "Danger Zone",
      description: "Wipe all operational data from the system. Use only for testing or when starting real operations.",
      wipeList1: "All vehicles, customers, rentals and payments",
      wipeList2: "All tolls, tickets, maintenance and contracts",
      wipeList3: "Activity history, photos and AI inspections",
      preservedNote: "✓ PRESERVED: System users (admin/operators) and settings (Stripe, Twilio, Zelle, PIX).",
      wipeButton: "Wipe Operational Data",
      confirmTitle: "This action CANNOT be undone.",
      typePhrase: "Type to confirm:",
      confirmWipe: "Confirm Wipe",
      success: "{{n}} records deleted. System reset.",
      wrongPhrase: "Wrong confirmation phrase. Type exactly: ZERAR TUDO",
    },
    ownerSignature: {
      title: "Owner Signature",
      description: "This signature is saved once and used automatically on all payment receipts (in PT, EN or ES according to the customer's preferred language).",
      ownerName: "Owner name",
      ownerTitle: "Title (optional)",
      titlePlaceholder: "e.g. Owner, Director, Manager",
      defaultTitle: "Owner",
      drawHere: "Draw your signature here →",
      clear: "Clear",
      save: "Save Signature",
      saved: "Signature saved — will be used on all receipts",
      remove: "Remove",
      removed: "Signature removed",
      confirmRemove: "Remove the signature? Future receipts won't have it.",
      redraw: "Redraw",
      updateNames: "Save names",
      nameRequired: "Enter the owner name",
      signatureRequired: "Draw your signature before saving",
    },
    profile: {
      pageTitle: "Profile",
      pageSubtitle: "Update your details and change your password.",
      accountInfo: "Account information",
      email: "Email",
      role: "Role",
      name: "Name",
      profileUpdated: "Profile updated",
      changePassword: "Change password",
      currentPassword: "Current password",
      newPassword: "New password",
      confirmPassword: "Confirm new password",
      passwordsDontMatch: "Passwords don't match",
      passwordTooShort: "Password must be at least 6 characters",
      passwordChanged: "Password changed successfully. Use the new one next login.",
      updatePassword: "Update password",
      passwordTips: "Tip: use at least 8 characters with uppercase letters, numbers and symbols.",
      strength: { weak: "Weak", fair: "Fair", good: "Good", strong: "Strong" },
      paymentTitle: "Payments (Zelle / PIX)",
      paymentSubtitle: "These details will be automatically included in every WhatsApp billing message. Zelle has no public API — the customer pays directly through their bank app using your email or phone.",
      paymentSaved: "Payment details saved",
      zelleEmail: "Zelle Email",
      zellePhone: "Zelle Phone",
      zelleAccountName: "Beneficiary name (on bank account)",
      pixKey: "PIX Key (Brazil customers — optional)",
      zelleQrTitle: "Zelle QR Code (optional)",
      zelleQrHint: "Open your bank app (Chase, BofA, Wells Fargo...) → Zelle → 'Generate QR' → screenshot → upload here. The QR will be included in billing messages.",
      uploadQr: "Upload QR Code",
      removeQr: "Remove",
      qrUploaded: "QR Code saved",
      qrRemoved: "QR Code removed",
      confirmRemoveQr: "Remove the Zelle QR Code?",
      savePayment: "Save payment details",
      remindersTitle: "Automated WhatsApp reminders",
      remindersHint: "Every day at 9 AM (Eastern time), the system automatically sends WhatsApp to customers who: (1) have a payment due TODAY or TOMORROW, or (2) are overdue. Each customer receives at most 1 message per day per state — no spam.",
      runRemindersNow: "Run now (test)",
      remindersDispatched: "✅ {{n}} reminder(s) sent",
      remindersFailed: "Failed to dispatch reminders",
      statSent: "Sent",
      statDedup: "Already sent",
      statNoPhone: "No phone",
      statErrors: "Errors",
      recentReminders: "Recent reminders",
      sandboxWarningTitle: "Test Environment Active",
      stripeSandboxLabel: "Stripe SANDBOX",
      stripeSandboxMsg: "Card payments are simulated. No real money is being deposited to your account. Replace STRIPE_API_KEY with 'sk_live_...' before operating with real customers.",
      twilioSandboxLabel: "Twilio WhatsApp SANDBOX",
      twilioSandboxMsg: "Messages are sent from test number {{from}}. The recipient must send 'join fell-usually' to that number once before receiving. Request Meta approval to use your Business number.",
    },
    paymentStatus: {
      paid: "Paid",
      dueSoon: "Due soon",
      overdue: "Overdue",
      unknown: "—",
      nextDue: "Next due",
      nextIn: "due in {{days}}d",
      upToDate: "up to date",
      today: "today",
      tomorrow: "tomorrow",
      inDays: "in {{days}}d",
      daysLate: "{{days}}d late",
    },
    collectionToday: {
      title: "COLLECTION TODAY",
      subtitle: "{{n}} customer(s) to charge · {{overdue}} overdue",
      totalDue: "Total due",
      chargeZelle: "Charge Zelle",
      allClear: "Nothing to collect today 🎉",
      allClearHint: "All active rentals are up to date.",
      sentSuccess: "✅ Charge sent automatically via WhatsApp",
      openOnWhatsapp: "Message ready — opening WhatsApp",
      noPhone: "Customer has no phone on file",
    },
    activity: {
      pageTitle: "ACTIVITY",
      heading: "Business Log",
      subtitle: "Complete timeline of your business · accounting & audit",
      totalEvents: "Total events",
      totalRevenue: "Revenue in period",
      rentalsCreated: "Rentals created",
      paymentsReceived: "Payments received",
      empty: "No activity in the selected period",
      emptyHint: "Adjust filters or create a rental.",
      types: {
        rental: "Rentals",
        payment: "Payments",
        customer: "Customers",
        car: "Cars",
        reminder: "Reminders",
        contract: "Documents",
      },
    },
    quickRental: {
      title: "Rent {{model}} ({{plate}})",
      subtitle: "Register the customer, set dates and generate the contract in seconds",
      customer: "Customer",
      searchExisting: "Search customer",
      newCustomer: "New customer",
      searchPlaceholder: "Name, phone or license...",
      noCustomers: "No customer found. Use 'New customer' to register.",
      selectedClient: "Selected customer",
      name: "Full name",
      phone: "Phone (with country code)",
      driverLicense: "Driver's License",
      email: "Email (optional)",
      financials: "Dates and amounts",
      pickup: "Pickup date",
      return: "Return date",
      weeklyRate: "Weekly rate ($)",
      deposit: "Deposit ($)",
      depositLabel: "Deposit",
      totalAtPickup: "Total due at pickup",
      openEnded: "Open-ended rental (no return date)",
      openEndedHint: "System will bill every 7 days",
      noReturnDate: "— Open-ended —",
      openEndedFooterHint: "Customer pays 1st week + deposit. Future charges run automatically every 7 days until the car is returned.",
      firstPeriod: {
        diaria: "1st day × ${{rate}}",
        semanal: "1st week × ${{rate}}",
        mensal: "1st month × ${{rate}}",
      },
      period: { daily: "Daily", weekly: "Weekly", monthly: "Monthly" },
      rateLabel: {
        diaria: "Daily rate ($)",
        semanal: "Weekly rate ($)",
        mensal: "Monthly rate ($)",
      },
      duration: {
        diaria: "{{n}} day(s)",
        semanal: "{{n}} week(s)",
        mensal: "{{n}} month(s)",
      },
      confirmAndPrint: "Confirm & open contract",
      created: "Rental created! Opening contract to print...",
      pdfFailed: "Rental created, but contract failed to open. Access via the rental.",
    },
  },

  es: {
    common: {
      loading: "Cargando…",
      systemOnline: "SISTEMA EN LÍNEA",
      cancel: "Cancelar",
      save: "Guardar",
      edit: "Editar",
      delete: "Eliminar",
      add: "Agregar",
      search: "Buscar...",
      all: "Todos",
      total: "Total",
      status: "Estado",
      date: "Fecha",
      description: "Descripción",
      amount: "Monto",
      value: "Valor",
      notes: "Observaciones",
      none: "Ninguno",
      select: "Seleccione...",
      confirmDelete: "¿Está seguro de que desea eliminar?",
      sessionLabel: "Sesión",
      logout: "Salir",
      operations: "Operaciones",
      print: "Imprimir",
      details: "Detalles",
      yes: "Sí",
      no: "No",
      never: "Nunca",
      open: "Abrir",
      back: "Volver",
      next: "Siguiente",
    },
    sidebar: {
      dashboard: "Panel",
      today: "Hoy",
      fleet: "Flota",
      customers: "Clientes",
      rentals: "Alquileres",
      payments: "Pagos",
      maintenance: "Mantenimiento",
      tickets: "Multas",
      tolls: "Peajes",
      gps: "Rastreo",
      financial: "Finanzas",
      billing: "Cobros",
      bi: "Inteligencia",
      activity: "Actividad",
      users: "Usuarios",
      profile: "Perfil",
    },
    login: {
      restrictedAccess: "Acceso restringido",
      signIn: "Iniciar sesión",
      useCredentials: "Use sus credenciales administrativas.",
      email: "Correo",
      password: "Contraseña",
      submit: "Entrar",
      defaultCreds: "Credenciales por defecto",
      systemVersion: "Sistema operativo · v1.0",
      heroTitle1: "Control total",
      heroTitle2: "sobre su flota.",
      heroDescription: "Flota, clientes, contratos, pagos, mantenimiento y rastreo GPS — en un único panel sofisticado.",
      heroFooter: "TODOS LOS SISTEMAS OK",
      brandSub: "Sistema OS",
    },
    dashboard: {
      available: "Disponibles",
      rented: "Alquilados",
      maintenance: "Mantenimiento",
      overdue: "Atrasados",
      revenueMonth: "Ingresos del mes",
      revenueTotal: "Ingresos totales",
      profit: "Ganancia estimada",
      upcoming: "Devoluciones 7d",
      ofVehicles: "de {{n}} vehículos",
      activeContracts: "{{n}} contratos activos",
      inWorkshop: "En taller",
      overdueReturns: "Devoluciones vencidas",
      confirmedPayments: "Pagos confirmados",
      accumulated: "Acumulado",
      expenses: "Gastos",
      scheduled: "{{n}} programados",
      revenue: "Ingresos",
      last6months: "Últimos 6 meses",
      fleet: "Flota",
      currentStatus: "Estado actual",
      noData: "Sin datos",
    },
    fleet: {
      pageTitle: "Flota · {{n}} vehículos",
      pageSubtitle: "Gestione sus vehículos, estado e información operativa.",
      newCar: "Nuevo vehículo",
      registerCar: "Registrar vehículo",
      editCar: "Editar vehículo",
      model: "Modelo",
      plate: "Placa",
      year: "Año",
      color: "Color",
      dailyPrice: "Diaria ($)",
      weeklyPrice: "Semanal ($)",
      monthlyPrice: "Mensual ($)",
      ratesTitle: "Tabla de precios",
      ratesHint: "Los valores se sugieren automáticamente cuando cambia uno — puede ajustar libremente.",
      weekShort: "sem",
      dailyAutoHint: "Diaria auto: ${{rate}} (semanal ÷ 7)",
      unknownRenter: "Cliente",
      dueOn: "Devuelve",
      overdue: "atrasado",
      today: "hoy",
      tomorrow: "mañana",
      pendingCharges: "Cargos pendientes",
      mileage: "Millas (mi)",
      gpsId: "ID del GPS",
      fuel: "Combustible",
      photo: "Foto (URL)",
      insurancePolicy: "Póliza de Seguro",
      insuranceExpiry: "Vencimiento Seguro",
      maInspectionExpiry: "Vencimiento Inspección MA",
      registrationExpiry: "Vencimiento Registration",
      ezpassTag: "EZPass / Transponder",
      vin: "VIN (Chasis)",
      emptyTitle: "Flota vacía",
      emptySub: "Registre su primer vehículo para comenzar.",
      registerFirst: "Registrar vehículo",
      rentNow: "Alquilar Ahora",
      searchPlaceholder: "Buscar por placa, modelo, color, año...",
      noResults: "Sin resultados",
      tryDifferent: "Pruebe otros términos de búsqueda.",
      sort: {
        newest: "Más recientes",
        oldest: "Más antiguos",
        plateAsc: "Placa (A→Z)",
        modelAsc: "Modelo (A→Z)",
        priceDesc: "Mayor diaria",
        priceAsc: "Menor diaria",
        mileageAsc: "Menor millaje",
        mileageDesc: "Mayor millaje",
      },
      status: {
        disponivel: "Disponible",
        alugado: "Alquilado",
        manutencao: "Mantenimiento",
      },
      created: "Vehículo registrado",
      updated: "Vehículo actualizado",
      deleted: "Vehículo eliminado",
      confirmDelete: "¿Eliminar este vehículo?",
    },
    customers: {
      pageTitle: "Clientes · {{n}} registrados",
      pageSubtitle: "Registro completo con Social Security, Driver License y contacto.",
      newCustomer: "Nuevo cliente",
      registerCustomer: "Registrar cliente",
      editCustomer: "Editar cliente",
      fullName: "Nombre completo",
      ssn: "Social Security (SSN)",
      license: "Driver License",
      phone: "Teléfono",
      email: "Correo",
      address: "Dirección",
      preferredLanguage: "Idioma preferido (para recibos y WhatsApp)",
      preferredLanguageHint: "Los recibos y mensajes automáticos se generarán en este idioma",
      emptyTitle: "Ningún cliente",
      emptySub: "Registre clientes para crear contratos de alquiler.",
      created: "Cliente registrado",
      updated: "Cliente actualizado",
      deleted: "Cliente eliminado",
      confirmDelete: "¿Eliminar cliente?",
    },
    rentals: {
      pageTitle: "Alquileres · {{n}} contratos",
      pageSubtitle: "Contratos, fechas y estado. Ingresos calculados automáticamente.",
      newRental: "Nuevo alquiler",
      openEnded: "Abierto",
      wizardBtn: "Nuevo alquiler rápido",
      editRental: "Editar alquiler",
      vehicle: "Vehículo",
      customer: "Cliente",
      pickup: "Retiro",
      return: "Devolución",
      billingType: "Tipo de cobro",
      daily: "Diaria",
      weekly: "Semanal",
      dailyRate: "Valor diaria ($)",
      weeklyRate: "Valor semanal ($)",
      deposit: "Depósito ($)",
      rentalValue: "Valor del alquiler",
      pickupTotal: "Total a cobrar al retiro",
      pickupHint: "Alquiler + Depósito · reembolsable",
      billing: "Cobro",
      perDay: "/día",
      perWeek: "/semana",
      paymentCol: "Pago",
      emptyTitle: "Sin contratos",
      emptySub: "Cree un alquiler para empezar a operar.",
      created: "Alquiler creado",
      updated: "Alquiler actualizado",
      deleted: "Alquiler eliminado",
      confirmDelete: "¿Eliminar alquiler?",
      detailsTitle: "Detalles, EZ-Pass y recibos",
      day: "día",
      days: "días",
      week: "semana",
      weeks: "semanas",
      status: {
        agendado: "Programado",
        ativo: "Activo",
        concluido: "Concluido",
        cancelado: "Cancelado",
      },
    },
    payments: {
      pageTitle: "Pagos · {{n}} registros",
      pageSubtitle: "Recibidos y pendientes por contrato.",
      newPayment: "Registrar pago",
      contract: "Contrato (alquiler)",
      amount: "Monto ($)",
      method: "Método",
      received: "Recibido",
      pending: "Pendiente",
      methods: {
        dinheiro: "Efectivo",
        pix: "PIX",
        zelle: "Zelle",
        cartao: "Tarjeta",
        transferencia: "Transferencia",
      },
      status: {
        pago: "Pagado",
        pendente: "Pendiente",
      },
      contractCol: "Contrato",
      emptyTitle: "Sin pagos",
      created: "Pago registrado",
      deleted: "Pago eliminado",
      confirmDelete: "¿Eliminar pago?",
      downloadReceipt: "Descargar recibo PDF",
    },
    maintenance: {
      pageTitle: "Mantenimiento · {{n}} registros · {{cost}} en gastos",
      pageSubtitle: "Historial de servicios por vehículo.",
      newMaintenance: "Registrar mantenimiento",
      newTitle: "Nuevo mantenimiento",
      serviceType: "Tipo de servicio",
      servicePlaceholder: "Ej: Cambio de aceite, Servicio 20.000mi",
      cost: "Costo ($)",
      mileageAt: "Millas al momento",
      performedAt: "Realizado el",
      nextAt: "Próximo el",
      optional: "opcional",
      service: "Servicio",
      next: "Próximo",
      miles: "Millas",
      emptyTitle: "Sin mantenimientos",
      created: "Mantenimiento registrado",
      deleted: "Mantenimiento eliminado",
      confirmDelete: "¿Eliminar mantenimiento?",
    },
    gps: {
      pageTitle: "Rastreo · {{n}} con GPS",
      pageSubtitle: "Última ubicación conocida y actualización manual de coordenadas. La integración en vivo se puede agregar después.",
      active: "Activo",
      noGps: "Sin GPS",
      device: "Dispositivo",
      latitude: "Latitud",
      longitude: "Longitud",
      odometer: "Odómetro",
      updated: "Actualizado",
      updateBtn: "Actualizar",
      updateTitle: "Actualizar ubicación",
      odometerInput: "Odómetro (mi)",
      hint: "Tip: pegue las coordenadas de Google Maps como lat, lng.",
      noVehicles: "Ningún vehículo registrado",
      locationUpdated: "Ubicación actualizada",
    },
    financial: {
      pageTitle: "Finanzas",
      revenueTotal: "Ingresos totales",
      revenueMonth: "Ingresos del mes",
      expenses: "Gastos",
      profit: "Ganancia",
      monthlyRevenue: "Ingresos mensuales",
      last6: "Últimos 6 meses",
      perVehicle: "Desempeño por vehículo",
      revenueVsCost: "Ingresos × Costos",
      vehicle: "Vehículo",
      revenue: "Ingresos",
      costs: "Costos",
    },
    receipt: {
      pickup: "Recibo de retiro",
      return: "Recibo de devolución",
      brand: "ALQUILER",
      receiptNo: "Recibo nº",
      pickupTitle: "RECIBO DE RETIRO",
      returnTitle: "RECIBO DE DEVOLUCIÓN",
      issuedAt: "Emitido el",
      customer: "Cliente",
      vehicle: "Vehículo",
      period: "Periodo del alquiler",
      pickupDate: "Retiro",
      returnDate: "Devolución",
      billing: "Cobro",
      quantity: "Cantidad",
      unitRate: "Valor unitario",
      rentalValue: "Valor del alquiler",
      pickupTotalSection: "Total a pagar al retiro",
      rental: "Alquiler",
      depositRefundable: "Depósito (reembolsable)",
      totalPaid: "TOTAL PAGADO",
      pickupNote: "* El depósito de {{deposit}} será devuelto al cliente al momento de la devolución del vehículo, descontando peajes (EZ-Pass), combustible faltante, limpieza, daños y otros gastos extras.",
      tollsSection: "Depósito y gastos extras",
      depositPaid: "Depósito pagado al retiro",
      tollsTotal: "Total gastos extras",
      noTolls: "Ningún gasto extra registrado.",
      refundSection: "Monto devuelto al cliente",
      depositLine: "Depósito",
      tollsDeduct: "(−) Gastos extras",
      refundedAmount: "MONTO DEVUELTO",
      excessNote: "* Los peajes exceden el depósito. El cliente debe pagar {{excess}} adicional.",
      signCustomer: "Cliente",
      signCompany: "Empresa",
      responsible: "Responsable",
      eDoc: "Documento emitido electrónicamente",
      ezpassCol: "Descripción",
    },
    rentalDetails: {
      depositLabel: "Depósito",
      ezpassTotal: "Total gastos extras",
      depositMinus: "Depósito − Gastos",
      pickupReceiptBtn: "Recibo de retiro",
      returnReceiptBtn: "Recibo de devolución",
      sendCheckinLink: "Check-in del cliente",
      checkinLinkCopied: "Enlace de check-in copiado",
      requestReview: "Pedir reseña Google",
      reviewLinkCopied: "Enlace copiado",
      ezpassSection: "Gastos extras · descontados del depósito",
      placeholderToll: "Ej: Puente GW",
      addToll: "Agregar",
      ezpassAdded: "Cargo agregado",
      removed: "Eliminado",
      category: "Categoría",
      categories: {
        ezpass: "EZ-Pass / Peaje",
        fuel: "Combustible",
        cleaning: "Limpieza",
        damage: "Daños",
        other: "Otros",
      },
      placeholders: {
        ezpass: "Ej: Puente GW",
        fuel: "Ej: Devuelto con tanque vacío (estaba lleno)",
        cleaning: "Ej: Limpieza interior profunda",
        damage: "Ej: Rayón en puerta delantera",
        other: "Ej: Multa de tránsito",
      },
      tabCharges: "Cobros",
      tabPhotos: "Fotos",
      tabChecklist: "Inspección",
      tabSignature: "Firma",
      tabReturnReport: "Informe devolución",
    },
    billing: {
      chargeViaWhatsapp: "Cobrar por WhatsApp",
      linkGenerated: "Enlace de pago generado",
      sentAutomatically: "✅ Cobro enviado automáticamente por WhatsApp",
      zelleOnly: "Cobrar por Zelle",
      zelleOnlyHint: "Envía solo datos de Zelle/PIX (sin enlace Stripe)",
      zelleSentAutomatically: "✅ Mensaje Zelle enviado automáticamente por WhatsApp",
      zelleMessageReady: "Mensaje Zelle listo",
      zelleReadyToSend: "Cobro Zelle listo",
      zelleQrShare: "El código QR de Zelle se compartirá con el cliente",
      linkCopied: "Enlace copiado",
      readyToSend: "Listo para enviar",
      openWhatsapp: "Abrir en WhatsApp",
      previewLink: "Ver enlace",
      copyLink: "Copiar enlace",
      previewMessage: "Mensaje que será enviado",
      noPhone: "Cliente sin teléfono",
      paymentSuccess: "¡Pago confirmado!",
      paymentSuccessMsg: "Gracias. Su transacción fue procesada exitosamente.",
      paymentCancelled: "Pago cancelado",
      paymentCancelledMsg: "Puede intentar nuevamente cuando lo desee.",
      backToApp: "Volver al sistema",
      checkingStatus: "Verificando estado del pago…",
    },
    billingPage: {
      title: "Cobros programados · {{n}} contratos",
      subtitle: "Alquileres semanales con cobro próximo en 48h o ya vencidos.",
      emptyTitle: "Todo al día",
      emptySub: "Ningún cobro pendiente en los próximos días.",
      dueIn: "Vence en",
      overdueBy: "Atrasado hace",
    },
    photos: {
      uploadBtn: "Subir fotos",
      dropHint: "Arrastre fotos aquí o haga clic para seleccionar (hasta 8MB c/u)",
      empty: "Aún no se subieron fotos.",
      uploadedN: "{{n}} archivo(s) subido(s)",
      deleted: "Foto eliminada",
      confirmDelete: "¿Eliminar esta foto?",
      carPhotos: "Galería del vehículo",
      carPhotosHint: "Fotos oficiales: exterior, interior, tablero, odómetro.",
      pickupCondition: "Estado al retiro",
      pickupConditionHint: "Documente el estado del vehículo al momento del retiro.",
      returnCondition: "Estado a la devolución",
      returnConditionHint: "Documente el estado y daños al momento de la devolución.",
      customerDocs: "Documentos del cliente",
      customerDocsHint: "Driver License, Social Security u otros. PDF e imágenes aceptados.",
    },
    signature: {
      title: "Firma digital del cliente",
      hint: "Use mouse o toque",
      placeholder: "FIRME AQUÍ",
      clear: "Limpiar",
      save: "Guardar firma",
      saved: "Firma guardada",
      savedAndStored: "Firma guardada y contrato archivado en el perfil del cliente",
      emptyError: "Firme antes de guardar.",
      remove: "Eliminar",
      removed: "Firma eliminada",
      confirmRemove: "¿Eliminar la firma?",
      signedOn: "Firmado el",
      initialsLabel: "Iniciales",
      initialsHint: "Escriba las iniciales del cliente (ej: JD). Se aplicarán automáticamente a las 24 cláusulas del contrato.",
      contractHint: "La firma aparece en el contrato PDF y el PDF se archiva automáticamente en el perfil del cliente.",
      contractStored: "Contrato firmado archivado",
      contractStoredHint: "PDF guardado en el perfil del cliente. Puede reabrirlo o descargarlo cuando quiera.",
      versionsSaved: "versión(es)",
      langBannerTitle: "Idioma del contrato",
      langBannerHint: "Elija el idioma — el PDF generado y archivado al firmar estará en ese idioma.",
    },
    contracts: {
      title: "Contratos firmados",
      subtitle: "Todos los contratos PDF firmados por este cliente quedan archivados aquí.",
      empty: "Aún no hay contratos firmados. Cuando el cliente firme un alquiler, el PDF aparecerá aquí automáticamente.",
      view: "Ver",
      download: "Descargar",
      send: "Enviar",
    },
    share: {
      title: "Enviar contrato al cliente",
      generating: "Generando enlace seguro...",
      publicLink: "Enlace público temporal",
      copy: "Copiar",
      linkCopied: "Enlace copiado",
      expiresIn: "Expira en {{days}} días · accesible para cualquiera con el enlace",
      viaWhatsapp: "Enviar por WhatsApp",
      viaEmail: "Enviar por Email",
      noPhone: "Cliente sin teléfono",
      noEmail: "Cliente sin email",
      previewMessage: "Mensaje previo",
      securityNote: "🔒 El enlace expira automáticamente. Puede revocarlo en cualquier momento generando uno nuevo.",
    },
    wizard: {
      title: "Nuevo alquiler",
      stepN: "Paso {{n}} de {{total}}",
      change: "Cambiar",
      cancelConfirm: "¿Cancelar el alquiler? Los datos no guardados se perderán.",
      rentalCreated: "Alquiler creado · ahora complete la inspección",
      completed: "Alquiler finalizado",
      completedWithContract: "Alquiler finalizado · contrato archivado en el perfil del cliente",
      steps: {
        customer:  { label: "Paso 1", short: "Cliente",   heading: "¿Quién está alquilando?",        description: "Elija un cliente existente o créelo al instante." },
        car:       { label: "Paso 2", short: "Vehículo",  heading: "¿Qué vehículo sale?",            description: "Toque el vehículo disponible para este alquiler." },
        period:    { label: "Paso 3", short: "Período",   heading: "¿Cuándo y cuánto?",              description: "Defina fechas, modalidad de cobro, depósito e idioma del contrato." },
        checklist: { label: "Paso 4", short: "Inspección",heading: "Inspección de retiro",           description: "Marque los 12 ítems, ajuste combustible y odómetro." },
        photos:    { label: "Paso 5", short: "Fotos",     heading: "Fotos del estado del vehículo",  description: "Documente exterior, interior y detalles antes de la entrega." },
        signature: { label: "Paso 6", short: "Contrato",  heading: "Revisar y firmar",               description: "Muestre el resumen, elija el idioma y recoja la firma." },
      },
      customer: { searchPlaceholder: "Buscar por nombre, teléfono, licencia o email...", new: "Nuevo cliente", newTitle: "Crear cliente", created: "Cliente creado", empty: "Ningún cliente encontrado." },
      car: { empty: "No hay vehículos disponibles. Libere un vehículo en la Flota antes de continuar." },
      period: { summary: "Resumen del período", unitRate: "Valor unitario", qty: "Cant. cobrada", contractLang: "Idioma del contrato", contractLangHint: "Pre-seleccione el idioma. Puede cambiarlo antes de firmar." },
      photos: { hint: "Las fotos quedan adjuntas a este alquiler y serán visibles en la devolución para comparación." },
      signature: { reviewTitle: "Resumen final · confirme con el cliente", finalize: "Finalizar y archivar contrato" },
    },
    checklist: {
      titlePickup: "Inspección de retiro",
      titleReturn: "Inspección de devolución",
      saved: "Inspección guardada",
      fuelLevel: "Nivel de combustible",
      odometer: "Odómetro (mi)",
      notesPlaceholder: "Notas de la inspección, daños identificados...",
      completedAt: "Completada el",
      items: {
        exterior_clean: "Exterior limpio",
        interior_clean: "Interior limpio",
        no_damage_body: "Sin daños en carrocería",
        no_damage_glass: "Sin daños en vidrios/espejos",
        tires_ok: "Neumáticos en buen estado",
        spare_tire: "Llanta de auxilio + gato",
        all_lights_ok: "Faros y señales ok",
        wipers_ok: "Limpiaparabrisas ok",
        documents_present: "Documentos del vehículo",
        key_count_ok: "Llaves completas",
        manual_present: "Manual del propietario",
        registration_present: "Registration card",
      },
    },
    contract: {
      openPdf: "Contrato PDF",
      storeInLang: "Guardar en {{lang}}",
      generated: "Contrato en {{lang}} generado y archivado en el perfil del cliente",
    },
    bi: {
      pageTitle: "Business Intelligence",
      pageSubtitle: "ROI por vehículo, proyección de ingresos y ocupación de la flota.",
      totalRevenue: "Ingresos totales",
      totalProfit: "Ganancia total",
      expenses: "Gastos",
      occupancy: "Ocupación promedio",
      fleetSize: "Tamaño de flota",
      activeRentals: "{{n}} alquileres activos",
      last90days: "Últimos 90 días",
      healthy: "Operación sana",
      atRisk: "Atención · ingresos < costos",
      forecastTitle: "Proyección",
      forecastSubtitle: "Ingresos reales × proyectados (30/60/90 días)",
      avgDaily: "Promedio diario",
      actual30: "Real 30d",
      actual60: "Real 60d",
      actual90: "Real 90d",
      projected30: "Proyección 30d",
      projected60: "Proyección 60d",
      projected90: "Proyección 90d",
      amount: "Monto",
      fleetPerformance: "Desempeño de flota",
      fleetPerformanceSubtitle: "ROI y ocupación por vehículo",
      vehicles: "vehículos",
      noVehicles: "Agregue vehículos para ver el desempeño.",
      vehicle: "Vehículo",
      rentals: "Alquileres",
      revenue: "Ingresos",
      profit: "Ganancia",
      roi: "ROI",
      occupancyShort: "Ocupación (90d)",
      topEarners: "Mejores performers",
      profitPerCar: "Ganancia por vehículo",
    },
    maintenanceV2: {
      pageTitle: "Mantenimiento & Flota",
      pageSubtitle: "Servicios programados, historial completo y registro de accidentes.",
      tabs: { services: "Servicios", history: "Historial", accidents: "Accidentes" },
      addService: "Agregar servicio",
      addAccident: "Registrar accidente",
      serviceType: "Tipo de servicio",
      lastDoneDate: "Última vez (fecha)",
      lastDoneMiles: "Última vez (millas)",
      intervalMiles: "Intervalo (millas)",
      intervalMonths: "Intervalo (meses)",
      intervalMilesHint: "Ej: 5000",
      intervalMonthsHint: "Ej: 6",
      daysLeft: "Días restantes",
      milesLeft: "Millas restantes",
      last: "Última",
      markPerformed: "Marcar como hecho",
      performTitle: "Marcar {{name}} como realizado",
      servicePerformed: "Servicio registrado · próxima fecha recalculada",
      serviceCreated: "Servicio agregado",
      serviceDeleted: "Servicio eliminado",
      confirmDeleteService: "¿Eliminar este servicio?",
      emptyServices: "Sin servicios activos",
      emptyServicesSub: "Agregue servicios como cambio de aceite, neumáticos y frenos para alertas automáticas.",
      emptyAccidents: "Ningún accidente registrado",
      accidentCreated: "Accidente registrado",
      accidentDeleted: "Accidente eliminado",
      confirmDeleteAccident: "¿Eliminar este registro?",
      incidentDate: "Fecha del incidente",
      estimatedCost: "Costo estimado",
      policeReport: "Reporte policial #",
      insuranceClaim: "Reclamo seguro #",
      thirdPartyInfo: "Tercero involucrado",
      thirdPartyHint: "Nombre / placa / seguro del otro (si lo hay)",
      types: {
        oil_change: "Cambio de aceite",
        tire_rotation: "Rotación de neumáticos",
        tire_replacement: "Cambio de neumáticos",
        brakes: "Frenos",
        ma_inspection: "Inspección MA",
        alignment: "Alineación",
        transmission_fluid: "Líquido de transmisión",
        battery: "Batería",
        other: "Otro",
      },
      severity: { overdue: "Vencido", soon: "Pronto", ok: "OK" },
      accidentStatus: { open: "Abierto", in_review: "En revisión", closed: "Cerrado" },
    },
    tickets: {
      pageTitle: "Multas · {{n}} registros · {{total}}",
      pageSubtitle: "Citaciones vinculadas automáticamente al alquiler activo a la fecha.",
      newTicket: "Nueva multa",
      citationNumber: "Número de citación",
      issueDatetime: "Fecha/hora de infracción",
      amount: "Monto",
      type: "Tipo",
      issuer: "Organismo emisor",
      location: "Ubicación",
      plateOnTicket: "Placa (anular)",
      plateHint: "Si difiere del vehículo seleccionado",
      selectCarHint: "Auto-detectar por placa",
      selectCarRequired: "Seleccione el vehículo *",
      carRequired: "Seleccione el vehículo antes de guardar.",
      createdNoActiveRental: "Multa registrada — sin alquiler activo en esa fecha",
      autoChargeHint: "Cobrar automáticamente al cliente (desde el depósito)",
      notLinked: "No vinculada",
      markPaid: "Marcar como pagada",
      markedPaid: "Multa marcada como pagada",
      created: "Multa registrada",
      createdAutoLinked: "Multa registrada y vinculada al alquiler activo",
      deleted: "Multa eliminada",
      confirmDelete: "¿Eliminar esta multa?",
      emptyTitle: "Sin multas registradas",
      emptySub: "Las multas aparecerán aquí al registrarse y se vinculan automáticamente.",
      types: {
        parking: "Estacionamiento",
        speeding: "Exceso de velocidad",
        red_light: "Luz roja",
        toll_violation: "Peaje no pagado",
        registration: "Documentación",
        other: "Otra",
      },
      status: { pending: "Pendiente", charged: "Cobrada", paid: "Pagada" },
    },
    tolls: {
      pageTitle: "Peajes · {{n}} registros · {{total}}",
      pageSubtitle: "Peajes EZ-Pass y Pay-By-Plate. Vinculación automática al alquiler activo.",
      newToll: "Nuevo peaje",
      datetime: "Fecha/hora",
      amount: "Monto",
      location: "Plaza / Ubicación",
      importCsv: "Importar CSV",
      csvHintTitle: "Importación masiva desde EZDriveMA",
      csvHintBody: "Exporte su extracto mensual en CSV (fecha, monto, placa, ubicación, transponder) y suéltelo aquí. El sistema vincula cada peaje al alquiler activo y cobra automáticamente.",
      ezpassTag: "EZPass / Transponder (opcional)",
      ezpassTagHint: "Ej: 02100123456789 — usado cuando la placa no coincide",
      importedN: "{{n}} peajes importados · {{linked}} vinculados",
      autoChargeHint: "Cobrar automáticamente al cliente (desde el depósito)",
      created: "Peaje registrado",
      createdAutoLinked: "Peaje registrado y vinculado al alquiler",
      deleted: "Peaje eliminado",
      confirmDelete: "¿Eliminar este peaje?",
      linked: "Vinculado",
      unlinked: "Sin vínculo",
      emptyTitle: "Sin peajes registrados",
      emptySub: "Importe un CSV de EZDriveMA o registre uno manualmente.",
      selectCarRequired: "Seleccione el vehículo *",
      carRequired: "Seleccione el vehículo antes de guardar.",
      createdNoActiveRental: "Peaje registrado — sin alquiler activo en esa fecha",
    },
    users: {
      pageTitle: "Usuarios del Sistema ({{n}})",
      pageSubtitle: "Invite a personas para acceder al sistema. Los Admins ven todo; los Operadores no ven Finanzas, BI, Actividad ni Usuarios.",
      invite: "Invitar usuario",
      inviteTitle: "Invitar nuevo usuario",
      name: "Nombre",
      email: "Correo",
      phone: "WhatsApp",
      phoneE164: "WhatsApp (formato internacional)",
      phoneHint: "Incluya el código del país. Ej: +15614556277 (EE.UU.) o +5511999998888 (Brasil)",
      role: "Rol",
      roleAdmin: "Admin",
      roleOperator: "Operador",
      roleAdminHint: "Acceso total — puede ver todo, configurar Stripe/Zelle y administrar usuarios.",
      roleOperatorHint: "Acceso operativo — puede gestionar flota, alquileres, peajes y pagos. No ve Finanzas/BI/Actividad/Usuarios.",
      whatsappHint: "Se enviará un enlace de invitación (válido por 7 días) por WhatsApp para que la persona cree su contraseña.",
      sendInvite: "Enviar invitación",
      inviteSent: "Invitación enviada a {{name}} por WhatsApp",
      inviteCreatedNoWhatsapp: "Usuario creado, pero WhatsApp falló: {{error}}",
      resendInvite: "Reenviar invitación",
      resendOk: "Invitación reenviada correctamente",
      resendFailed: "Reenvío falló: {{error}}",
      statusActive: "Activo",
      statusPending: "Pendiente",
      statusInactive: "Desactivado",
      activate: "Activar",
      deactivate: "Desactivar",
      you: "tú",
      confirmDelete: "¿Eliminar a {{name}} permanentemente?",
      deleted: "Usuario eliminado",
      emptyTitle: "Aún no hay usuarios",
      emptySub: "Haga clic en \"Invitar usuario\" para agregar a alguien al sistema.",
    },
    acceptInvite: {
      welcomeBadge: "Bienvenido a Movix",
      helloName: "Hola, {{name}}!",
      bodyIntro: "Ha sido invitado a acceder al sistema como {{role}}. Cree su contraseña abajo para activar el acceso.",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar contraseña",
      activate: "Activar acceso",
      passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
      passwordsDontMatch: "Las contraseñas no coinciden",
      success: "¡Contraseña creada! Redirigiendo al login...",
      successTitle: "¡Acceso activado!",
      redirecting: "Redirigiendo a la pantalla de login…",
      invalidTitle: "Invitación inválida",
      backToLogin: "← Volver al login",
    },
    linkPreview: {
      checking: "Verificando alquiler vinculado…",
      willLink: "Se vinculará a:",
      noMatch: "Sin alquiler activo encontrado",
      noMatchHint: "Sin alquiler activo en esta fecha, este registro queda independiente.",
    },
    aiInspector: {
      title: "Inspección por IA",
      subtitle: "Compara fotos de retiro vs devolución con Gemini Vision y detecta nuevos daños. También lee el medidor de combustible.",
      runBtn: "Analizar con IA",
      analyzing: "Analizando…",
      completed: "Análisis completo",
      failed: "Fallo en el análisis",
      empty: "Aún no hay análisis. Suba fotos de retiro y devolución para que la IA pueda compararlas.",
      confidence: "Confianza",
      suggestedCharge: "Cargo sugerido",
      applyCharge: "Aplicar cargo",
      applyChargeTotal: "Cobrar {{amount}} del depósito",
      confirmApply: "¿Aplicar este cargo contra el depósito del cliente?",
      chargeApplied: "Cargo aplicado al alquiler",
      alreadyApplied: "Cargo ya aplicado",
      damages: "Daños detectados",
      modalTitle: "Análisis IA listo · revisar con el cliente",
      reviewLater: "Revisar después",
      fuel: {
        title: "Medidor de combustible",
        pickup: "Retiro",
        return: "Devolución",
        missing: "Faltante",
        calc: "Tanque {{tank}} gal · ${{price}}/gal · cargo {{charge}} (incluye tarifa de servicio si falta >5%)",
        damageLabel: "Daños",
        fuelLabel: "Combustible",
      },
      verdict: {
        no_new_damage: "Sin daños nuevos detectados",
        new_damage_detected: "Posibles daños detectados",
        inconclusive: "Análisis inconcluso",
      },
    },
    returnReport: {
      title: "Informe de Devolución",
      subtitle: "PDF oficial firmable que combina recibo, inspección, análisis IA, cargos y firma del cliente. Prueba legal vinculante (ESIGN Act + M.G.L. c. 110G) contra chargebacks.",
      deposit: "Depósito pagado",
      charges: "Cargos extras",
      refund: "A reembolsar",
      due: "Cliente debe",
      previewPdf: "Previsualizar PDF",
      previewError: "Error al abrir el PDF. Inténtelo de nuevo.",
      customerSignature: "Firma del cliente",
      signatureHint: "Muestre el PDF al cliente en el iPad. Al firmar, el sistema genera y archiva el documento final automáticamente.",
      signAndStore: "Firmar y archivar",
      savedAndStored: "Informe firmado y archivado",
      storedTitle: "Versiones archivadas",
      closingTitle: "Cierre detallado",
      milesAtPickup: "Millas al retiro",
      milesAtReturn: "Millas a la devolución",
      milesDriven: "Millas recorridas",
      lastLocation: "Última ubicación GPS",
      tollsTitle: "Peajes de este alquiler",
      ticketsTitle: "Multas de este alquiler",
      noTolls: "Sin peajes registrados.",
      noTickets: "Sin multas registradas.",
    },
    dangerZone: {
      title: "Zona de Peligro",
      description: "Borrar todos los datos operacionales del sistema. Use solo para pruebas o al iniciar la operación real.",
      wipeList1: "Todos los vehículos, clientes, alquileres y pagos",
      wipeList2: "Todos los peajes, multas, mantenimientos y contratos",
      wipeList3: "Historial de actividades, fotos e inspecciones IA",
      preservedNote: "✓ PRESERVADO: Usuarios del sistema (admin/operadores) y configuraciones (Stripe, Twilio, Zelle, PIX).",
      wipeButton: "Borrar Datos Operacionales",
      confirmTitle: "Esta acción NO se puede deshacer.",
      typePhrase: "Escriba para confirmar:",
      confirmWipe: "Confirmar Borrado",
      success: "{{n}} registros eliminados. Sistema reiniciado.",
      wrongPhrase: "Frase de confirmación incorrecta. Escriba exactamente: ZERAR TUDO",
    },
    ownerSignature: {
      title: "Firma del Propietario",
      description: "Esta firma se guarda una vez y se usa automáticamente en todos los recibos de pago (en PT, EN o ES según el idioma del cliente).",
      ownerName: "Nombre del propietario",
      ownerTitle: "Cargo (opcional)",
      titlePlaceholder: "Ej: Propietario, Director, Gerente",
      defaultTitle: "Propietario",
      drawHere: "Dibuje su firma aquí →",
      clear: "Limpiar",
      save: "Guardar Firma",
      saved: "Firma guardada — se usará en todos los recibos",
      remove: "Eliminar",
      removed: "Firma eliminada",
      confirmRemove: "¿Eliminar la firma? Los próximos recibos no la tendrán.",
      redraw: "Rehacer",
      updateNames: "Guardar nombres",
      nameRequired: "Ingrese el nombre del propietario",
      signatureRequired: "Dibuje su firma antes de guardar",
    },
    profile: {
      pageTitle: "Perfil",
      pageSubtitle: "Actualice sus datos y cambie su contraseña.",
      accountInfo: "Información de la cuenta",
      email: "Correo electrónico",
      role: "Rol",
      name: "Nombre",
      profileUpdated: "Perfil actualizado",
      changePassword: "Cambiar contraseña",
      currentPassword: "Contraseña actual",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar nueva contraseña",
      passwordsDontMatch: "Las contraseñas no coinciden",
      passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
      passwordChanged: "Contraseña cambiada con éxito.",
      updatePassword: "Actualizar contraseña",
      passwordTips: "Sugerencia: use al menos 8 caracteres con mayúsculas, números y símbolos.",
      strength: { weak: "Débil", fair: "Aceptable", good: "Buena", strong: "Fuerte" },
      paymentTitle: "Pagos (Zelle / PIX)",
      paymentSubtitle: "Estos datos se incluirán automáticamente en cada cobro enviado por WhatsApp. Zelle no tiene API pública — el cliente paga directamente desde la app de su banco usando su email o teléfono.",
      paymentSaved: "Datos de pago guardados",
      zelleEmail: "Email Zelle",
      zellePhone: "Teléfono Zelle",
      zelleAccountName: "Nombre del beneficiario (en el banco)",
      pixKey: "Clave PIX (clientes Brasil — opcional)",
      zelleQrTitle: "Código QR Zelle (opcional)",
      zelleQrHint: "Abra la app de su banco (Chase, BofA, Wells Fargo...) → Zelle → 'Generate QR' → captura → suba aquí. El QR se incluirá en los cobros.",
      uploadQr: "Subir código QR",
      removeQr: "Eliminar",
      qrUploaded: "Código QR guardado",
      qrRemoved: "Código QR eliminado",
      confirmRemoveQr: "¿Eliminar el código QR de Zelle?",
      savePayment: "Guardar datos de pago",
      remindersTitle: "Recordatorios automáticos por WhatsApp",
      remindersHint: "Todos los días a las 9h (hora del este), el sistema envía automáticamente WhatsApp a clientes que: (1) tienen pago venciendo HOY o MAÑANA, o (2) están atrasados. Cada cliente recibe máximo 1 mensaje por día por estado — sin spam.",
      runRemindersNow: "Disparar ahora (prueba)",
      remindersDispatched: "✅ {{n}} recordatorio(s) enviado(s)",
      remindersFailed: "Error al disparar recordatorios",
      statSent: "Enviados",
      statDedup: "Ya enviados",
      statNoPhone: "Sin teléfono",
      statErrors: "Errores",
      recentReminders: "Recordatorios recientes",
      sandboxWarningTitle: "Entorno de Pruebas Activo",
      stripeSandboxLabel: "Stripe en SANDBOX",
      stripeSandboxMsg: "Los pagos con tarjeta son simulados. Ningún dinero real está llegando a su cuenta. Reemplace STRIPE_API_KEY por 'sk_live_...' antes de operar con clientes reales.",
      twilioSandboxLabel: "Twilio WhatsApp en SANDBOX",
      twilioSandboxMsg: "Los mensajes se envían desde el número de prueba {{from}}. El destinatario debe enviar 'join fell-usually' a ese número una vez antes de recibir. Solicite aprobación Meta para usar su número Business.",
    },
    paymentStatus: {
      paid: "Pagado",
      dueSoon: "Por vencer",
      overdue: "Atrasado",
      unknown: "—",
      nextDue: "Próximo vencimiento",
      nextIn: "vence en {{days}}d",
      upToDate: "al día",
      today: "hoy",
      tomorrow: "mañana",
      inDays: "en {{days}}d",
      daysLate: "{{days}}d de atraso",
    },
    collectionToday: {
      title: "COBRO DE HOY",
      subtitle: "{{n}} cliente(s) por cobrar · {{overdue}} atrasados",
      totalDue: "Total por recibir",
      chargeZelle: "Cobrar Zelle",
      allClear: "Nada por cobrar hoy 🎉",
      allClearHint: "Todos los alquileres activos están al día.",
      sentSuccess: "✅ Cobro enviado automáticamente por WhatsApp",
      openOnWhatsapp: "Mensaje listo — abriendo WhatsApp",
      noPhone: "Cliente sin teléfono",
    },
    activity: {
      pageTitle: "ACTIVIDAD",
      heading: "Diario de a Bordo",
      subtitle: "Línea de tiempo completa de su negocio · contabilidad & auditoría",
      totalEvents: "Total de eventos",
      totalRevenue: "Ingresos en el período",
      rentalsCreated: "Alquileres creados",
      paymentsReceived: "Pagos recibidos",
      empty: "Sin actividad en el período seleccionado",
      emptyHint: "Ajuste los filtros o cree un alquiler.",
      types: {
        rental: "Alquileres",
        payment: "Pagos",
        customer: "Clientes",
        car: "Coches",
        reminder: "Recordatorios",
        contract: "Documentos",
      },
    },
    quickRental: {
      title: "Alquilar {{model}} ({{plate}})",
      subtitle: "Registre al cliente, fije fechas y genere el contrato en segundos",
      customer: "Cliente",
      searchExisting: "Buscar cliente",
      newCustomer: "Nuevo cliente",
      searchPlaceholder: "Nombre, teléfono o licencia...",
      noCustomers: "Sin clientes. Use 'Nuevo cliente' para registrar.",
      selectedClient: "Cliente seleccionado",
      name: "Nombre completo",
      phone: "Teléfono (con código país)",
      driverLicense: "Licencia de conducir",
      email: "Email (opcional)",
      financials: "Fechas y montos",
      pickup: "Fecha de retiro",
      return: "Fecha de devolución",
      weeklyRate: "Tarifa semanal ($)",
      deposit: "Depósito ($)",
      depositLabel: "Depósito",
      totalAtPickup: "Total a cobrar en la entrega",
      openEnded: "Alquiler abierto (sin fecha de devolución)",
      openEndedHint: "El sistema cobrará cada 7 días",
      noReturnDate: "— Abierto —",
      openEndedFooterHint: "El cliente paga la 1ª semana + depósito. Próximos cobros serán automáticos cada 7 días hasta la devolución.",
      firstPeriod: {
        diaria: "1er día × ${{rate}}",
        semanal: "1ª semana × ${{rate}}",
        mensal: "1er mes × ${{rate}}",
      },
      period: { daily: "Diaria", weekly: "Semanal", monthly: "Mensual" },
      rateLabel: {
        diaria: "Tarifa diaria ($)",
        semanal: "Tarifa semanal ($)",
        mensal: "Tarifa mensual ($)",
      },
      duration: {
        diaria: "{{n}} día(s)",
        semanal: "{{n}} semana(s)",
        mensal: "{{n}} mes(es)",
      },
      confirmAndPrint: "Confirmar y abrir contrato",
      created: "¡Alquiler creado! Abriendo contrato para imprimir...",
      pdfFailed: "Alquiler creado, pero el contrato no se pudo abrir. Acceda desde el alquiler.",
    },
  },
};

export default translations;
